<script>
// 定义常量提高代码可读性
const FREQUENCY_TYPE = {
    DAILY: [3, 4, 5, 7],      // 日维度类型
    WEEKLY: [2, 6],              // 周维度类型
    MONTHLY: 1                   // 月维度类型
};

const TIME_RANGE_INDEX = {
    TODAY: 0,
    YESTERDAY: 1,
    CUSTOM: 2
};

const d = new Date()
const year = d.getFullYear()
let month = d.getMonth() + 1
month = month < 10 ? `0${month}` : month
const date = d.getDate()


import Layout from "../../layouts/main";
import infiniteScroll from 'vue-infinite-scroll';
import appConfig from "@/app.config";

import CustomDialogHeader from '@/components/CustomDialogHeader.vue'
import {
  activityDetail,
  getProjectManageAdmin,
  getSignListMore,
  SignListComment,
  getSignListComment,
  updatecommentlanguage,
  updateScore,
  clockNameListByName,
  getNoticeListMore,
  noticeThumbsUp,
  delNoticeThumbsUp,
  signDel,
  getActivityCode,
  startImmediately,
  restartActivity,
  earlyTermination,
  delSignOrder,
  delActivity,
  getShareLink
} from "@/utils/api/activity";
import { imageUrl } from "@/utils/config/commonUrl.js";
export default {
    directives: { infiniteScroll },
    page() {
    // 动态生成标题
    const title =
      this.activityDetail && this.activityDetail.name
        ? `${this.activityDetail.name} - 接龙详情`
        : `接龙详情`;

    return {
      title: title,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
    components: { Layout,CustomDialogHeader },
    data() {
        return {
          noticeListMore: [],
          isNotice: '0',
          typeCopyIdx: 0,
          readNum: 0,
          unreadNum: 0,
          unreadClockNameList: [],//未读名单
          readClockNameList: [],//已读名单
          NoticeListpageNum: 1,
          manageDialogVisible:false,
          manageTip: '',
          manageTitle:'',
          codeUrl:'',
          calendarShow: false, // 控制日历显示的状态
          shareTypeNew: false,
          morePop: false,
          isDel:false,
          setBoxShow: false,
          setInfo: {},
          activityDetail: {},
          thumbsUpId:0,
          thumbsUpNumber:0,
          scoreTypelist:[{
            name:'ABC打分'
            },
                {
                    name:'分数打分',
                },
                {
                    name:'优良打分',
                },
                {
                    name:'自定义打分',
                }],

            scoreBoxShow:false,
            scoreType:0,
            score:null,
            ABCScore:['A+','A','B','C','D','D-'],
            excellentScore:['优+','优','良','中','差','很差'],
            addcomment:'',
            comment:'',
            commentBoxShow:false,
            remarkBoxShow:false,
            sortArr:[
                {
                    choose :1,
                    name:'允许他人查看',
                },
                {
                    choose :2,
                    name:'不允许他人查看',
                },
                {
                    choose:3,
                    name:'已评分',
                },
                {
                    choose:4,
                    name:'未评分',
                }

            ],
            classArr:[
                {
                    sortType:1,
                    name:'时间倒序',
                },
                {
                    sortType:2,
                    name:'时间正序',
                },
                {
                    sortType :3,
                    name:'姓名排序',
                },
            ],
            bannIndex:0,

            index:0,
            joinUserNum:1,//参加报名人数
            // fmSignListId:'',
            leavemessage:'',

                signId:'',
                name:'',
                mSelect:[],
                isOtherPeople: 3, // 1=创建者、2=管理员、3=普通用户

                orderId:'',
                placeholderText1: '',
                placeholderText2: '',
                placeholderText3: '',
                videoPlay:false,//视频播放
                // 滚动容器高度
                scrollHeight: '',

                defaultDateMultiple: [`${year}-${month}-${date}`],
                minDateMultiple: `${year}-${month}-${date-30}`,
                maxDate: `${year}-${month}-${date-30}`,
                monthNum: 3,
                zhanKai: true,
                isShowLoading: false,
                isTemplate: '', //是否通过模板进来
                templatePage: '2', //1通过模板进来 2或者空不是从模板进入的
                isType: '', //活动类型
                isStop: '',
                clockLocationStatus: false, //是否在打卡范围内
                cardReplacementsNumber: '', //剩余打卡次数
                cardReplacementsNumberFlag: '',
                clockInfo: {
                    clockLocationInfo: {}
                }, //打卡信息
                clockNameList: [], //接龙名单
                projectVos: [], //活动项目集合
                isClick: true,
                locationObj: {}, //获取当前位置信息
                imageUrl2: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/',
                imageUrl: imageUrl,
                dateValue: '',
                selectType: '',
                modular: [],
                signField: [],
                signList: [],
                signNum: 0,
                commentList: [],
                pageNum: 1,
                pageSize: 10,
                memberId: 0,
                mySignInfo: {
                    id: ''
                },
                // 留言弹窗
                isShowMess: false,
                //留言内容
                commentContent: '',
                commentId: '',
                innerAudioContext: '',
                video: null,
                iconFiexd: false,
                DisappearShow: false,
                title: 1,
                msgText: '',
                shareShow: false,
                menuButtonInfo: '', //导航胶囊位置信息
                posterPath: '',

                signInfo: [],
                shareType: false, //分享弹窗
                sharePYQ: false, //分享朋友圈提示图片
                isShowT0: false,
                ShowBill: false,
                redBaob: 1,
                bdNewwode: this.imageUrl + '/static/newTwo/redbaoB.png',
                redShowdiv: 1, //控制弹窗红包是否显示

                billUrl: '',
                posterUrl: '', //返回时的弹窗分享图
                posternormal: '', //其他分享图
                onlyshareimg: '', //上一页报名返回的分享图
                base64Head: "data:image/png;base64,",

                ewmImg: '', //活动二维码
                fmSignListId: '', //页面传递回来的分组id、
                copyUrl: '',
                optionsscene: '', //小程序场景值
                shareImgClone: '/static/share/admin_pic16696994024988.jpg',
                detailNumber: 1,
                coverImgH: '',
                sharefriendpic: '',
                mySignInfoId: '',
                covers: [],
                logoImg: 'static/newImg/jieLong.png',
                pageType: '',
                address_is_allowed: true,
                cancelSignInfo: '活动终止前',
                signlength: 0,
                msgSeeMoreShow: false,
                memberPopShow: false,
                memberPopTitle: '提示',
                memberPopContent: '邀请您成为管理员',
                invite: '', // 1 展示邀请弹框
                projectAdminList: [], // 管理员列表
                managePopShow: false,
                delactPopShow: false,
                delactPopTitle: '提示',
                delactPopContent: '确定删除？',
                earlyPopShow: false,
                earlyPopTitle: '提示',
                earlyPopContent: '是否提前结束？',
                is_draft: '3',
                tosignClick: false,
                zkgd: true,
                zkgdState: true,
                zkxqIsShow: false,
                isHidden: false,
                hiddenBtn: '',
                isReady: true, //骨架屏
                crPopShow: false,
                crPopTitle: '提示',
                crPopContent: '是否提前取消？',
                commActiveState: '',

                resetPopShow: false,
                resetPopTitle: '提示',
                resetPopContent: '是否立即重启？',

                quicklyStartPopShow: false,
                quicklyStartPopTitle: '提示',
                quicklyStartPopContent: '是否立即重启？',

                saveVideoPopShow: false,
                saveVideoPopTitle: '提示',
                saveVideoPopContent: '是否保存视频到相册',
                touchStartTime: 0,
                longPressThreshold: 500, // 长按的阈值，单位是毫秒
                saveVideoUrl: '',
                active_state: '2',
                clockFrequencyType: '99',
                weekChineseNumbers: ['一', '二', '三', '四', '五', '六', '日'],

                saveAudioUrl: '',
                saveAudioPopShow: false,
                saveAudioPopTitle: '提示',
                saveAudioPopContent: '是否保存音频到手机',
                // touchStartTime: 0,
                // longPressThreshold: 500 ,// 长按的阈值，单位是毫秒
                is_template: '',
                shown: false,
                isAd: true,
                unitId: "",
                plugScreenUnitId: "",
                addVideoUnitid: "",
                bannerUnitId: "",
                totalRow: '',
                registraList: [],
                pllist:[],
                choose: "",

                sortType: 1,
                updateName: '', //取消报名时用的
                getSignListByActivityData: '',
                timeSort: 3,
                timePickerArr: [
                    ['今天', '昨天', '自定义选择日期']
                ],
                timePickerShow: false,
                notregistered: [], //未报名人员列表
                registerednum: 0, //已报名人数
                solitairenName: '', // 名单搜索参数
                signupCalendarShow: false,
                dksignupCalendarShow: false,
                calendar: {
                    minDate: '',
                    maxDate: '',
                    defaultDate: '',
                    monthNum: 100,
                },
                dktimePickerShow: false,


                dktimePickerArr:[
                    {
                        name: '今天',
                        index: 0
                    },
                    {
                        name: ' 昨天',
                        index: 1
                    },
                    {
                        name: '自定义选择日期',
                        index: 2
                    },

                ],

                dktimeChangeIndex:0 ,
                timeChangeIndex:0,
                cloneClocknameLength: 0,
                cloneregistralength: 0,
                isDelOrder: '', // 修改填表项的话传1，不修改不传
                clockNameListTemp: [
                    {
                        clockNameStatus: 0,
                        clockName: '李娜'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '张伟豪'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '王芳怡'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '赵雷宇'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '刘洋然'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '陈静轩'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '杨阳彤'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '杨阳彤'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '吴昊轩'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '徐婷萱'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '郑洁思'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '孙浩宇轩'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '黄磊明'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '高婷怡'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '郭阳文'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '曹颖欣'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '高婷怡'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '谢飞杰'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '韩雪琪'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '唐宁远'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '马超然'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '朱晓萱'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '胡志豪'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '林嘉怡'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '罗思远'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '梁伟杰'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '许静彤'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '邓浩宇'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '冯文轩'
                    },
                    {
                        clockNameStatus: 0,
                        clockName: '程梓萱'
                    },

                ],
                showModal: false,
                disjunctor: true, // 防止连点
                groupId: '',
                selectedMonth: {
                    year: new Date().getFullYear(),
                    month: new Date().toLocaleString('default', {
                        month: 'long'
                    })
                },
                // selectedDate: "2024-03-18", // 默认选中日期
                weekMaxDate: "2050-12-31",
                defaultWeekDate:`${year}-${month}-${date}`,
                monthShow: false,
                weekPicker:false,
                pages: 1,
                registraListTotal: '',
                registraPageNum:1,
                registrapages:1,
                hasMore: true,
                isLoading: false ,// 加载状态
                windowHeight: 0 ,// 页面可视高度
                downOption: {
                    auto: false, //是否在初始化后,自动执行downCallback; 默认true
                },
                upOption: {
                    auto: false
                },
                mescroll:'',
                is_scroll_div: false,
                loadingFlag: false,
                loadingFinished: false,
                filterType:1,//1名单2报名列表
                nodataFinished: false,
                showResetButton:false,
                locateIt: false, // 是否去定位
                is_destination: 0, // 是否开启指定位置 1开 0关
                isSearch:false,
                isButtonClicked: false, // 防止连点
                filterArrShow: false,
                filterClockNameList: [],
                phbImgSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/paihangbang1.png',

                shareImg1: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-pyq.svg',
                shareImg2: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-erweima.svg',
                shareImg3: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-gzh.svg',
                shareImg4: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-fxhb.svg',
                shareImg5: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-wx.svg',
                shareImg6: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-sclj.svg',
                shareImg7: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/shareImg-zdyfx.svg',
                showCommentCount: 2, // 默认显示的评论数量
                commentStep: 5, // 每次加载的评论数量
                isLastPage: false,// 是否已经加载到最后一页
                plpageNum :1,
                commentPageNums: {}, // 存储每个对象的当前页码
                commentPageNumbers: {}, // 存储每个报名对象的评论页码
                commentStates:{},
                nameAddType: '', // 判断是姓名还是分组
                packetData: [], // 展示再页面的分组数据
                pickerName: '全部',
                pickerNameSelectShow: false,
                pickerNameSelectArr: [], // 中间值
                nameListLength: 0, // 名单人数
                filteredArr: [],

                manageImgSrc1: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-bianji.svg',
                manageImgSrc2: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-guanliyuan.svg',
                manageImgSrc3: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-tiqianjieshu.svg',
                manageImgSrc4: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-tiqianjieshu.svg',
                manageImgSrc5: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-tiqianjieshu.svg',
                manageImgSrc6: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/manage-buka.svg',
                manageImgSrc7: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-fuzhi.svg',
                manageImgSrc8: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/m-share1.svg',
                manageImgSrc9: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/25_trash.svg',
                manageImgSrc10: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/manage-buka.svg',
                manageImgSrc11: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-index-daochu.svg',
                manageImgSrc12: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/25_shujutongji.svg',
                manageImgSrc13: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/25_zhuanrang.svg',
                manageImgSrc14: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/act-copyBtn.svg',
                manageImgSrc15: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/sct-shareBtn.svg',
                qunliaoImgSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/qunliao.png',
                firstDontGo: true,
                chatNumTimer:null,//获取群聊消息数量定时器
                fromBatchDraw: false, // 是否从批图页面返回
                batchDrawOrderId: null, // 批图页面返回的填表项ID
                isInFolder: 1, // 是否在文件夹内 默认 1 否 2 是
                folderId: '', // 文件夹ID
                dontGo: false,
                turnShareTitle: '您的好友转让了一条接龙给您，点击成为发布人',
                turnShareImg: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/becameBuilder.png',
                turnSharePath: '/pages/solataireGroupDetails/solataireGroupDetails?id=' + this.activityId +
                    '&selectType=see'+ '&isType=' + this.isType + '&masterID=' + this.memberId,
                isTurnTo: 2, // 2 不是转让 1 转让
                masterID: '',
                selectOptionShow: false,
                selectOptionList: [
                    {
                        name:'下载到微信'
                    }
                ],
                commonFileUrl: '',
                commonLastName: '',
                commonFileName: '',
                selectedPickerName: '',
                activeTab: 0,
                activityId: '',
                // 分享相关属性
                dialogVisible: false,
                shareTitle: '',
                JumpUrl: '',
                faceUrl: '',
                shareChange: '下载接龙二维码',
                appid: 'wx1234567890abcdef', // 小程序ID
                isAcive: '嵌入到公众号',

        };
    },
    mounted() {
        this._getActivityInfo();
    },
    computed: {
        setMb() {
            return function(size, fileType) {
                if (size == '') {
                    return ''
                } else {
                    let infoSize = size / 1048576
                    if (fileType == "mp3" || fileType == "MP3" || fileType == "Mp3" || fileType == "mP3") {
                        return "音频大小：" + Math.floor(infoSize) + "MB"
                    } else if (fileType == "mp4" || fileType == "MP4" || fileType == "Mp4" || fileType == "mP4") {
                        return "视频大小：" + Math.floor(infoSize) + "MB"
                    } else {
                        return "文件大小：" + Math.floor(infoSize) + "MB"
                    }
                }
            }
        },
        setKb() {
            return function(size, fileType) {
                if (size == "") {
                    return ''
                } else if (size == 0) {
                    return "文件大小：" + 0 + "KB"
                } else {
                    let infoSize = size / 1024
                    if (fileType == "mp3" || fileType == "MP3" || fileType == "Mp3" || fileType == "mP3") {
                        return "音频大小：" + Math.floor(infoSize) + "KB"
                    } else if (fileType == "mp4" || fileType == "MP4" || fileType == "Mp4" || fileType == "mP4") {
                        return "视频大小：" + Math.floor(infoSize) + "KB"
                    } else {
                        return "文件大小：" + Math.floor(infoSize) + "KB"
                    }
                }
            }
        },
        setB() {
            return function(size, fileType) {
                if (size == "") {
                    return ''
                } else if (size == 0) {
                    return "文件大小：" + 0 + "B"
                } else {
                    let infoSize = size
                    if (fileType == "mp3" || fileType == "MP3" || fileType == "Mp3" || fileType == "mP3") {
                        return "音频大小：" + Math.floor(infoSize) + "B"
                    } else if (fileType == "mp4" || fileType == "MP4" || fileType == "Mp4" || fileType == "mP4") {
                        return "视频大小：" + Math.floor(infoSize) + "B"
                    } else {
                        return "文件大小：" + Math.floor(infoSize) + "B"
                    }
                }
            }
        },
        seconde() {
            return function(time) {
                let s = parseInt(Number(time) / 1000)
                let ss = parseInt((Number(time) - (s * 1000)) / 100)
                return s + '.' + ss + 's'
            }
        },
        //过滤星期
        // formattedDays() {
        //     if(this.clockInfo.clockFrequency){
        //         const daysMap = ['周一', '周二', '周三', '周四', '周五', '周六','周日'];
        //         // 分割字符串并转换为数字，过滤无效值
        //         const days = this.clockInfo.clockFrequency.split(',')
        //             .map(num => Number(num.trim()))
        //             .filter(num => num >= 0 && num <= 6);
        //         // 转换为星期并拼接成字符串
        //         return days.map(num => daysMap[num]).join(', ');
        //     }

        // }


    },
    methods: {
      // 编辑修改
      dropdownSet(row) {
        console.log(row, "去编辑--内容");
        console.log(row.createId != row.user_id);
        console.log(row.is_admin == 2);

        if ((row.createId && row.createId != row.user_id) || row.is_admin == 2) {
          this.$message.error("没有权限修改");
          return false;
        }

        if (row.activity_big_type == 2) {
          // 通知公告类型
          let routeData = this.$router.resolve({
            path: "/groupNotification",
            query: {
              alias: row.activityKey,
              selectType: "update",
              isType: row.activity_type,
            },
          });
          window.open(routeData.href, "_blank");
        } else {
          if (row.activity_type == 303) {
            // 特殊类型303，需要扫码编辑
            this.fetchActivityCode(row);
            this.manageDialogVisible = true;
            this.manageTitle = '编辑';
            this.manageTip = '请扫码进入小程序活动详情进行修改';
          } else {
            // 通用接龙类型
            let routeData = this.$router.resolve({
              path: "/solitaire",
              query: {
                alias: row.activityKey,
                selectType: "update",
                isType: row.activity_type,
              },
            });
            window.open(routeData.href, "_blank");
          }
        }
      },

      // 设置管理员
      setAdmin(row) {
        this.fetchActivityCode(row);
        this.manageDialogVisible = true;
        this.manageTitle = '设置管理员';
        this.manageTip = '请扫码进入小程序邀请管理员';
      },

      // 导出数据
      exportData(row) {
        let routeData = this.$router.resolve({
          path: "/exportDataPage?activityId=" + row.id,
        });
        window.open(routeData.href, "_blank");
      },

      // 数据统计
      toPageStatistics(row) {
        let routeData = this.$router.resolve({
          path: "/dataStatistics?activityId=" + row.id,
        });
        window.open(routeData.href, "_blank");
      },

     // 复制
	dropdownCopy(row) {
		console.log(row, "row");

		// 根据活动类型跳转到不同页面
		if (row.activity_big_type == 2) {
			// 通知公告类型
			let routeData = this.$router.resolve({
				path: "/groupNotification",
				query: {
					alias: row.activityKey,
					selectType: "add",
					isType: row.activity_type,
					copy: true,
				},
			});
			window.open(routeData.href, "_blank");
		} else if (row.activity_type == 303) {
			// 特殊类型303，需要扫码编辑
			this.fetchActivityCode(row);
			this.manageDialogVisible = true;
			this.manageTitle = '复制';
			this.manageTip = '请扫码进入小程序复制活动';
		} else {
			// 通用接龙类型
			let routeData = this.$router.resolve({
				path: "/solitaire",
				query: {
					alias: row.activityKey,
					selectType: "add",
					isType: row.activity_type,
					copy: true,
				},
			});
			window.open(routeData.href, "_blank");
		}
	},

      // 立即开始/重启/提前结束
      dropdownEnd(row) {
        var toastMessage = "";

        if (row.active_state == 1) {
          toastMessage = "是否立即开始该活动";
        } else if (row.active_state == 2) {
          toastMessage = "是否立即重启该活动";
        } else if (row.active_state == 3) {
          toastMessage = "是否提前结束该活动";
        }

        this.$confirm(toastMessage, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (row.active_state == 1) {
              startImmediately({
                id: row.id,
              }).then((res) => {
                console.log(res, "立即开始接口");
                this.$message({
                  type: "success",
                  message: "成功!",
                });
                this._getActivityInfo();
              });
            } else if (row.active_state == 2) {
              restartActivity({
                id: row.id,
              }).then((res) => {
                console.log(res, "重启活动接口");
                this.$message({
                  type: "success",
                  message: "成功!",
                });
                this._getActivityInfo();
              });
            } else if (row.active_state == 3) {
              earlyTermination({
                id: row.id,
                is_it_over: 2,
                userId: localStorage.getItem("userID"),
              }).then((res) => {
                console.log(res, "提前结束接口");
                this.$message({
                  type: "success",
                  message: "成功!",
                });
                this._getActivityInfo();
              });
            }
          })
          .catch(() => { });
      },

      // 清空数据
      dropdownResetData(row) {
        console.log(row, "row");
        this.$confirm("确认清空全部参与记录吗？确认后将无法恢复，请谨慎操作。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delSignOrder({
              activityId: row.id,
            }).then((res) => {
              console.log(res, "清空接口");
              this.$message({
                type: "success",
                message: "成功!",
              });
              this.getSignListMore();
            })
              .catch(() => { });
          })
      },

      // 删除
      dropdownDel(row) {
        if (row.active_state == 2) {
          this.$confirm("确定删除该活动吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              delActivity({
                activityId: row.id,
              }).then((res) => {
                console.log(res, "删除接口");
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.$router.go(-1);
              });
            })
            .catch(() => { });
        } else {
          this.$confirm("是否立即结束当前活动，并删除活动？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              earlyTermination({
                id: row.id,
                is_it_over: 2,
                userId: localStorage.getItem("userID"),
              }).then((res) => {
                delActivity({
                  activityId: row.id,
                }).then((res) => {
                  console.log(res, "删除接口9999");
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.$router.go(-1);
                });
              });
            })
            .catch(() => { });
        }
      },

      // 签到码
      handleSignCode(row) {
        this.codeUrl = this.imageUrl + row.signInUrl;
        this.manageDialogVisible = true;
        this.manageTitle = '签到';
        this.manageTip = '请扫码进入小程序签到';
      },

      // 核销
      handleVerify(row) {
        this.fetchActivityCode(row);
        this.manageDialogVisible = true;
        this.manageTitle = '核销';
        this.manageTip = '请扫码进入小程序核销';
      },

      // 分享功能
      shareClick(row) {
        this.JumpUrl = ''; // 重置JumpUrl
        // 根据活动类型设置活动链接
        if (row.activity_big_type == 2) {

          this.faceUrl = '/pages-mine/previewTemplate/previewTemplate?alias=' + row.activityKey + '&selectType=see&isType=' + row.activity_type;
        } else if (row.activity_big_type == 1 && row.activity_type != 108) {

          this.faceUrl = '/pages/solataireGroupDetails/solataireGroupDetails?alias=' + row.activityKey + '&selectType=see&isType=' + row.activity_type;
        } else if (row.activity_big_type == 3) {

          this.faceUrl = '/pages-mine/poster/poster?alias=' + row.activityKey + '&selectType=see';
        } else if (row.activity_type == 108) {
          this.faceUrl = '/pages-mine/solitaireDetails/solitaireDetails?alias=' + row.activityKey + '&selectType=see&isType=' + row.activity_type;
        }

        if (row.is_folder) {
          this.shareTitle = "分享" + "    " + "    " + "    " + row.folderName;
        } else {
          this.shareTitle = "分享" + "    " + "    " + "    " + row.name;
        }

        this.fetchActivityCode(row); // 获取二维码并设置JumpUrl
        this.dialogVisible = true;
      },

      // 复制文本到剪贴板
      copyClick(text) {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(() => {
            this.$message.success('复制成功');
          }).catch(() => {
            this.$message.error('复制失败');
          });
        } else {
          // 兼容旧浏览器
          const textArea = document.createElement('textarea');
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            this.$message.success('复制成功');
          } catch (err) {
            this.$message.error('复制失败');
          }
          document.body.removeChild(textArea);
        }
      },

      // 处理教程按钮点击
      clickHandler(type) {
        this.isAcive = type;
      },
      handelChangetab(idx){
        this.typeCopyIdx =idx
      },
        toSign(){
          this.fetchActivityCode();
          this.manageDialogVisible = true;
          this.manageTitle = this.activityDetail.name;
          this.manageTip = '扫码进入活动详情确认通知';
        },



      fetchActivityCode(row) {
        const activityId = row ? row.id : this.activityId;
        const activityType = row ? row.activity_type : this.activityDetail.activity_type;

        let scene = "id=" + activityId + "&st=see&ity=" + activityType;
        getActivityCode({
          activityId: activityId,
          page: "pages/solataireGroupDetails/solataireGroupDetails",
          scene: scene,
        }).then((res) => {
          if (res.status == 1) {
            this.codeUrl = this.imageUrl + res.data.smallCode;
            console.log(this.codeUrl,'this.codeUrl')
          }
        });

        // 获取分享链接
        if (row) {
          getShareLink({ activityId: row.id }).then((res) => {
            if (res.status == 1) {
              this.JumpUrl = res.data.shareLink;
            }
          });
        }
      },
      downLoadCodePic(url) {
        this.downloadIamge(url, new Date().valueOf());
      },
      //
      downloadIamge(imgsrc, name) {
        // 下载图片地址和图片名
        var image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "Anonymous");
        image.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.fillStyle = "#FFFFFF";
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;

      },
      toWebdiv(type){
        if(type == 'gzh'){
          this.manageTitle = '公众号';
          this.manageTip = '请扫码进入小程序查看';
        }
        if(type == 'xcx'){
          this.manageTitle = '小程序';
          this.manageTip = '请扫码进入小程序查看';
        }
        if(type == 'sph'){
          this.manageTitle = '视频号';
          this.manageTip = '请扫码进入小程序查看';
        }
        this.fetchActivityCode();
        this.manageDialogVisible = true;
      },
     async delSign(item,index) {
       if (this.activityDetail.userId != this.memberId) {
         return
       }
       if (!this.isClick) {
         return
       }
       this.isClick = false
       this.$confirm('是否删除', '提示', {
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(async () => {
         const {
           msg,
           status
         } = await signDel({
           "activityId": this.activityId,
           "id": item.id,
           "userId": item.user_id,
         })
         if (status == 1) {
           this.noticeListMore = []
           await this._getNoticeListMore()
           await this.searchData()
           if (this.mySignInfo.user_id == this.memberId) {
             this.mySignInfo = {}
           }
         }else{
           this.$message({
             message: '删除失败',
             duration: 2000,
           })
         }
       }).catch(() => {

         this.$message({
           message: '取消删除',
           duration: 2000,
         })
       });

        this.isClick = true
      },
      async thumbsUp() {
            if (this.templatePage == 1){
                return false
            }
            var that = this;
            if (this.isClick == false) {
                return false;
            }
            this.isClick = false
            if (that.isNotice == '0') {

                const {
                    data,
                    status
                } = await noticeThumbsUp({
                    "activityId": this.activityId
                })
                if (status == 1) {
                    that.activityDetail.noticeNumber = data
                    that.isNotice = '1'
                    that.isClick = true
                } else {
                    that.isClick = true

                }
            } else if (this.isNotice == '1') {
                const {
                    data,
                    status
                } = await delNoticeThumbsUp({
                    "activityId":this.activityId
                })
                if (status == 1) {
                    this.isClick = true
                    this.activityDetail.noticeNumber = data
                    this.isNotice = '0'
                } else {
                    this.isClick = true

                }
            }

        },
        // 获取通知记录
        async _getNoticeListMore() {
            const {
                data,
                status
            } = await getNoticeListMore({
                "activityId": this.activityDetail.id,
                "pageNum": this.NoticeListpageNum,    //分页
                "pageSize": 10   //分页显示条数  默认10  不需要传
            })
            if (status == 1) {
                this.noticeListMore = data.pageInfo.list
                this.hasMore = data.pageInfo.hasNextPage;
                this.readNum = data.pageInfo.total
                console.log(this.readNum,'readNum')
                if (data.pageInfo.pages == data.pageInfo.pageNum){
                    this.loadingFlag = false;
                    this.loadingFinished = true;
                }
                if (this.noticeListMore.length == 0){
                    this.nodataFinished = true;
                    this.loadingFlag = false;
                    this.loadingFinished = false;
                } else {
                    this.loadingFlag = false;
                    this.nodataFinished = false;
                    this.loadingFinished = true;
                }


            }
        },
        timeAndDKtimeChangeHandler(index, value, sourceType, performSearchOrReset) {
            // 根据 sourceType 记录当前操作索引和选择器值
            if (sourceType === 'time') {
                this.timeChangeIndex = index;
            } else if (sourceType === 'dktime') {
                this.dktimeChangeIndex = index;
                this.timeChangeIndex = index;
            }
            if(index==0||index==1){
                this.setTimePickerConfig(this.clockFrequencyType)
            }
            // 根据不同的统计频率类型处理时间范围
            if (FREQUENCY_TYPE.DAILY.includes(this.clockFrequencyType)) {
                this.handleDailyFrequency(index, performSearchOrReset);
            } else if (FREQUENCY_TYPE.WEEKLY.includes(this.clockFrequencyType)) {
                this.handleWeeklyFrequency(index,performSearchOrReset);
            } else if (this.clockFrequencyType === FREQUENCY_TYPE.MONTHLY) {
                this.handleMonthlyFrequency(index,performSearchOrReset);
            }
            for (let key in this.commentStates) {
                this.commentStates = {
                    ...this.commentStates,
                    [key]: {
                        ...this.commentStates[key],
                        pageNum: 1
                    }
                };
            }

            // this._getSignListComment(this.orderId, 1)
            // 根据 performSearchOrReset 参数执行相应的操作
            if (!(index == 2 && FREQUENCY_TYPE.DAILY.includes(this.clockFrequencyType))) {
                if (performSearchOrReset === 'search') {
                    this.searchData();
                    this.registraList = [];
                    if (this.isButtonClicked) return;
                    this.isButtonClicked = true;
                    this.loadingFinished = false;
                } else if (performSearchOrReset === 'reset') {
                    this.registraList = [];
                    if (this.isButtonClicked) return;
                    this.isButtonClicked = true;
                    this.loadingFinished = false;

                }
            }
        },
            /**
             * 计算两个日期相差的月份
             * @param {Date} minDate - 第一个日期对象
             * @param {Date} maxDate - 第二个日期对象
             * @returns {number} 相差的月份数
             */
            // 计算两个日期相差月份的方法
            getMonthDifference(minDate, maxDate) {
                const startDate = this.$dayjs(minDate);
                const endDate = this.$dayjs(maxDate);
                let months = endDate.year() * 12 + endDate.month();
                months -= startDate.year() * 12 + startDate.month();
                if (endDate.date() < startDate.date()) {
                    months--;
                }
                return months;
            },

            /* 处理日维度时间范围 */
            async handleDailyFrequency(index, performSearchOrReset) {
                const today = this.$dayjs();

                switch (index) {
                    case TIME_RANGE_INDEX.TODAY:{
                        this.setDateRange(today, today);
                        this.dateValue = today.format('YYYY-MM-DD');
                        break;
                    }

                    case TIME_RANGE_INDEX.YESTERDAY:{

                        const yesterday = today.subtract(1, 'day');
                        this.setDateRange(yesterday, yesterday);
                        this.dateValue = yesterday.format('YYYY-MM-DD');
                        break;

                    }
                default:{
                    let monthDifference;
                    if (performSearchOrReset === 'search') {
                        this.minDateMultiple =this.$dayjs(this.activityDetail.beginTime).format('YYYY-MM-DD');
                        this.maxDate = this.$dayjs(this.activityDetail.endTime).format('YYYY-MM-DD');
                         monthDifference = this.getMonthDifference(this.minDateMultiple, this.maxDate);
                        this.monthNum= monthDifference+1;
                        // this.dksignupCalendarShow = true;
                        this.calendarShow = !this.calendarShow; // 切换日历显示状态
                        this.calendarShow =true

                    } else if (performSearchOrReset === 'reset') {
                        this.minDateMultiple = this.$dayjs(this.activityDetail.beginTime).format('YYYY-MM-DD');
                        this.maxDate = this.$dayjs(this.activityDetail.endTime).format('YYYY-MM-DD');
                        // this.maxDate = '2025-05-31';
                        console.log( this.minDateMultiple,this.maxDate)
                        monthDifference = this.getMonthDifference(this.minDateMultiple, this.maxDate);
                        this.monthNum= monthDifference+1;
                        this.calendarShow =true
                        // this.$refs.calendar.open();
                        this.$refs.signupCalendarShow.open();
                    }

            }
                }

            },
              /* 处理周维度时间范围 */
              handleWeeklyFrequency(index,performSearchOrReset) {
                switch (index) {
                    case TIME_RANGE_INDEX.TODAY:  // 本周
                        this.setDateRange(
                            this.$dayjs().startOf('week'),
                            this.$dayjs() .endOf('week')
                        );
                        break;
                    case TIME_RANGE_INDEX.YESTERDAY:  // 上周
                        this.setDateRange(
                            this.$dayjs().subtract(1, 'week').startOf('week'),
                            this.$dayjs().subtract(1, 'week').endOf('week')
                        );
                        break;
                    default:
                        if (performSearchOrReset === 'search') {
                            this.filterType = 1;
                        } else if (performSearchOrReset === 'reset') {
                            this.filterType = 2;
                        }
                        this.$refs.weekPicker.open();
                }
            },

            /* 处理月维度时间范围 */
            handleMonthlyFrequency(index,performSearchOrReset) {
                switch (index) {
                    case TIME_RANGE_INDEX.TODAY:{
                        this.setDateRange(
                            this.$dayjs().startOf('month'),
                            this.$dayjs().endOf('month')
                        );
                        break;
                    }  // 本月

                    case TIME_RANGE_INDEX.YESTERDAY: {
                        const lastMonth = this.$dayjs().subtract(1, 'month');
                        this.setDateRange(
                            lastMonth.startOf('month'),
                            lastMonth.endOf('month')
                        );
                        break;
                    } // 上月

                    default: {
                        if (performSearchOrReset === 'search') {
                            this.filterType = 1;
                        } else if (performSearchOrReset === 'reset') {
                            this.filterType = 2;
                        }
                        this.monthShow = true;
                        break;
                    }
                }
            },
            // * 通用设置日期范围方法 */
            setDateRange(startDate, endDate) {
                this.startQueryTime = startDate.format('YYYY-MM-DD');
                this.endQueryTime = endDate.format('YYYY-MM-DD');
            },
            handleDateChange(selectedDate) {
                console.log('父组件接收到的日期:', selectedDate);
                // 在这里处理日期变化
            },

         // 搜索
         async searchData() {
            console.log('看看执行几次')
            if(this.solitairenName==''){
                this.showResetButton = false;
            }else{
                this.showResetButton = true
            }
            if (this.templatePage == 1) {
                return false;
            }
            var that = this;
            this.filterClockNameList = []
            await clockNameListByName({
                "name": this.solitairenName, //要搜索的姓名  目前不使用模糊查询
                "activityId":this.activityId, //活动id
                "activityType": this.activityDetail.activityType, //活动类型
                "startQueryTime":this.startQueryTime,
                "endQueryTime" :this.endQueryTime,
                "listGroupName":this.pickerName=='全部'?'':this.pickerName,
            }).then((res) => {
                this.filterClockNameList = res.data
                this.filterClockNameList.map((res, index) => {
                    if (res.clockName == "") {
                        this.filterClockNameList.splice(index, 1)
                    }
                })
                that.registerednum = that.getRegistered()
                this.filterArrShow = true;

            })
        },
        //重置名单搜索状态
        resetSearch(){
            this.solitairenName = ''
            this.searchData()
            this.registraList = [];
            if (this.isButtonClicked) return;
            this.isButtonClicked = true;
            this.showResetButton= false
            this.filterArrShow = false;
        },
        clearSearchName(){
            this.dktimeChangeIndex = 0;
            this.timeChangeIndex = 0;
            this.isSearch = false
            this.solitairenName = '';
            this.filterArrShow = false;
        },
        handleSearch(){
            console.log('点击搜索按钮')
            this.isSearch=true
        },
        // 下拉刷新
        loadMore() {
            console.log('加载更多数据');
        },
        cancel(){
            // this.handlemodelChange(false)
            // this.score =null
            // this.addcomment=""
            this.scoreBoxShow = false
            this.commentBoxShow = false
            this.remarkBoxShow = false
        },
        // 点评
        commentOpen(item){
            this.setInfo = item
            this.commentBoxShow = true
            this.placeholderText1 = '';
            setTimeout(()=>{
                this.placeholderText1 = '请输入评语'
            },350)
        },
        // 评分
        openScoreDialog(item) {
            this.scoreBoxShow = true; // 打开评分对话框
            this.setInfo = item; // 将当前项存储到一个变量中以便在对话框中使用
        },
        handleInputNumber(event){
            let value = event.target.value;
            if (value < 0) {
                this.score = 0;
            } else if (value > 150) {
                this.score = 150;
            }
        },
        async changeScore(e){
            this.score = e
        },
        clickScope(e){
            this.scoreType = e.index
            this.score =null
        },
        addRemark(item){
            this.orderId =item.id
            this.setInfo = item
            this.remarkBoxShow = true;
            this.placeholderText2 = '';
            setTimeout(()=>{
                this.placeholderText2 = '请输入评论'
            },300)
        },
        seeMoreComments(id) {
            // 获取当前对象的评论状态，如果不存在则初始化
            const currentState = this.commentStates[id] || { showCount: 2, isLastPage: false, pageNum: 1 ,totalRow:0};
            // 更新显示的评论数量
            currentState.showCount += 2;

            // 更新该对象的评论状态
            this.commentStates = {
                ...this.commentStates,
                [id]: currentState
            };

            // 加载当前对象的评论，使用当前对象的 pageNum
            this._getSignListComment(id, currentState.pageNum);
        },
        async confirmRate(){
            if(!this.isClick){
                return false;
            }
            this.isClick = false
            if(this.score==null){
                this.isClick =true
                this.$message({
                    title: '请选择评分',
                    icon: 'none',
                    duration: 2000
                })
                return false;
            }
            const {
                data,
                status
            } = await updateScore({
                "id":this.setInfo.id,
                "activityId": this.activityId,
                'score':this.score,
            })
            if (status == 1) {
                this.score =null
                if (this.isButtonClicked) return;
                this.isButtonClicked = true;

                this.isClick = true
                this.scoreBoxShow = false

            }else{
                this.isClick = true
                this.scoreBoxShow = false

                this.$message({
                    title: data.msg,
                    icon: 'none',
                    duration: 2000
                })
            }
        },
        async confirmComment(){
            if(!this.isClick){
                return false;
            }
            this.isClick = false
            if(this.addcomment==null||this.addcomment==""){
                this.isClick =true
                this.$message({
                    title:'请输入评语',
                    icon:'none',
                    duration:2000
                })
                return false;
            }
            const {
                data,
                status
            } = await updatecommentlanguage({
                "id":this.setInfo.id,
                "activityId": this.activityId,
                'addcomment':this.addcomment,
            })
            if (status == 1) {
                this.addcomment =null
                setTimeout(() => {
                    this.isClick = true
                }, 3000);
                // await this.getData()
                if (this.isButtonClicked) return;
                this.isButtonClicked = true;
                this.commentBoxShow = false

            }else{
                this.addcomment =null

                this.commentBoxShow = false
                this.$message({
                    title:data.msg,
                    icon:'none',
                    duration:2000
                })
            }
        },

        async confirmRemark(){
            if(!this.isClick){
                return false;
            }
            this.isClick = false
            if(this.comment==null||this.comment==""){
                this.isClick =true
                this.$message({
                    title:'请输入评论',
                    icon:'none',
                    duration:2000
                })
                return false;
            }
            const {
                data,
                status
            } = await SignListComment({
                "orderId":this.orderId,
                "activityId":this.activityId,
                'comment':this.comment,
                "profilePhoto":this.activityDetail.profilePhoto,
                "name":this.activityDetail.publisher,
                "groupId":this.activityDetail.groupId
            })
            if (status == 1) {
                this.comment =null
                if (this.isButtonClicked) return;
                this.isClick = true
                this.remarkBoxShow = false
                this.commentStates = {
                    ...this.commentStates,
                    [this.orderId]: {
                        ...this.commentStates[this.orderId],
                        pageNum: 1
                    }
                };
                this._getSignListComment(this.orderId, 1)
            }else{
                this.isClick = true
                this.remarkBoxShow = false
                this.$message({
                    title:data.msg,
                    icon:'none',
                    duration:2000
                })
            }

        },
        showPickerNameSetup(){
            this.pickerNameSelectShow = true;
        },
        selectGrouping(e){
            console.log(e,'分组-选中分组')
            this.pickerName = e
            this.pickerNameSelectShow = false;

            // 切换下面的数据
            // 筛选逻辑（示例：保留所有 listGroupName 存在的项）
            if (e != '全部'){
                this.filteredArr = this.clockNameList.filter(item => {
                    return item.listGroupName == this.pickerName; // 精确匹配
                });
            } else {
                this.filteredArr = JSON.parse(JSON.stringify(this.clockNameList));
                this.filterArrShow = false;
            }
            console.log(this.filteredArr,'分组-选中分组的数据')
            this.filterClockNameList = this.filteredArr;
            this.filterArrShow = true;
            this.searchData()
            this.registraList = [];

        },
        closeGroupingPicker(){
            this.pickerNameSelectShow = false;
        },
          // 自定义月份
          monthhandleChange(value) {
            console.log(value,'jjj')
            if(value === null){
                this.startQueryTime =this.$dayjs().startOf('month').format('YYYY-MM-DD');
                this.endQueryTime = this.$dayjs().endOf('month').format('YYYY-MM-DD');
                value = this.$dayjs().format('YYYY-MM');
                console.log(this.startQueryTime,this.endQueryTime)
            }else{
                let specificDate = this.$dayjs()(value);
                // 获取这个月的第一天（月初）
                const startOfSpecificMonth = specificDate.startOf('month');
                this.startQueryTime = startOfSpecificMonth.format('YYYY-MM-DD')
                // 获取这个月的最后一天（月末）
                const endOfSpecificMonth = specificDate.endOf('month');
                this.endQueryTime = endOfSpecificMonth.format('YYYY-MM-DD')
            }
            if(this.filterType==1){
                const newItem = { index: 2, name:`${value}`};
                this.dktimePickerArr.splice(this.dktimePickerArr.length - 1, 1, newItem);
                this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
                this.searchData()
                this.registraList = [];
                if (this.isButtonClicked) return;
                this.isButtonClicked = true;

            }else if(this.filterType==2){
                const newItem = { index: 2, name:`${value}`};
                this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
                this.registraList=[]
                if (this.isButtonClicked) return;
                this.isButtonClicked = true;

            }
            this.monthShow = false
        },
        // 自定义周
        // handleWeekChange(week) {
        //     console.log(week,'week')
        //     this.startQueryTime = week.startDate
        //     this.endQueryTime = week.endDate
        //     const [year, month, day] = week.startDate.split('-');
        //     const [y,m,d] =  week.endDate.split('-');
        //     this.defaultWeekDate = week.startDate
        //     var weekStartData= `${month.padStart(2, '0')}.${day.padStart(2, '0')}`
        //     var weekEndData= `${m.padStart(2, '0')}.${d.padStart(2, '0')}`
        //     if(this.filterType==1){
        //         this.searchData()
        //         this.registraList = [];
        //         if (this.isButtonClicked) return;
        //         this.isButtonClicked = true;
        //         this.mescroll.resetUpScroll();
        //         const newItem = { index: 2, name:`${weekStartData}-${weekEndData}`};
        //         this.dktimePickerArr.splice(this.dktimePickerArr.length - 1, 1, newItem);
        //         this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
        //     }else if(this.filterType==2){
        //         const newItem = { index: 2, name:`${weekStartData}-${weekEndData}`};
        //         this.timePickerArr.splice(this.timePickerArr.length - 1, 1, newItem);
        //         this.registraList=[]
        //         if (this.isButtonClicked) return;
        //         this.isButtonClicked = true;
        //         this.mescroll.resetUpScroll();
        //     }
        // },
        onMonthChange(month) {
            this.selectedMonth = {
                year: month.year,
                month: month.month.replace('月', '')
            };
        },
       async  copynotregistered(){
            var notregistered = this.clockNameList.filter((item) => item.clockNameStatus == 2)
                var copyname = notregistered.map(user => user.clockName).join(',');
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    try {
                        await navigator.clipboard.writeText(copyname);
                        alert('复制成功！');
                    } catch (err) {
                        console.error('复制失败', err);
                    }
                } else {
                    // 备用方案：使用传统方法
                    const textArea = document.createElement('textarea');
                    textArea.value = copyname;
                    document.body.appendChild(textArea);
                    textArea.select();
                    try {
                        document.execCommand('copy');
                        alert('复制成功！');
                    } catch (err) {
                        console.error('复制失败', err);
                    }
                    document.body.removeChild(textArea);
                }
        },
        async copyContent(textToCopy) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                try {
                    await navigator.clipboard.writeText(textToCopy);
                  this.$message({
                    message: '复制成功',
                    duration: 2000,
                    type: 'success'
                  })
                } catch (err) {
                  this.$message({
                    message: '复制失败',
                    duration: 2000,
                    type: 'success'
                  })
                }
            } else {
                // 备用方案：使用传统方法
                const textArea = document.createElement('textarea');
                textArea.value = textToCopy;
                document.body.appendChild(textArea);
                textArea.select();
                try {
                    document.execCommand('copy');
                  this.$message({
                    message: '复制成功',
                    duration: 2000,
                    type: 'success'
                  })
                } catch (err) {
                  this.$message({
                    message: '复制失败',
                    duration: 2000,
                    type: 'success'
                  })
                }
                document.body.removeChild(textArea);
            }
        },
    // 打开文件
    openWen(url, fileType, fileName) {
        // 自动将 http 替换为 https
        if (url.startsWith('http://')) {
            url = url.replace('http://', 'https://');
        }
        const predivTypes = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        if (predivTypes.includes(fileType.toLowerCase())) {
            window.open(url, '_blank');
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || '';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
        async _getActivityInfo() {
            var that = this;
            let obj = {
                "activityKey": this.$route.query.alias,
                "selectType":"sign",
                "fmSignListId":this.fmSignListId,
                "orderId":this.orderId,
                "queryTime":this.queryTime,
            }
            // if (this.isTemplate == 'template') {
            //     //通过模板进来
            //     obj = {
            //         "templateIsShow": '99',
            //         "templateId": this.activityId,
            //         "selectType": this.selectType,
            //     }
            // } else {
            //     obj = {
            //         "activityId": this.activityId,
            //         "selectType": 'see',
            //     }
            // }
            // obj["is_template"] = this.is_template;
            const {
                data,
                status
            } = await activityDetail(obj)

            if (status == 1 && data && data.activityDetail) {
                this.activityDetail = data.activityDetail;
                this.activityId = data.activityDetail.id;
            } else {
                // 没有数据时直接返回
                return;
            }

            this._getProjectManageAdmin();
            // 指定参与地点开关
            this.is_destination = data.activityDetail.is_destination;

            this.is_draft = data.activityDetail.is_draft;
            if (data.modular) {
                data.modular.map((item) => {
                    item.info = item.info.replace(/\n/g, "\\n")
                    let info = JSON.parse(item.info)
                    item.info = info
                    if (item.type == 6) {
                        item.info.filesArr.forEach((itemSon) => {
                            itemSon.playMusic = false
                        })
                    }

                    if (item.type == 4) {
                        that.covers.push({
                            id: 9001,
                            latitude: item.info.latitude,
                            longitude: item.info.longitude,
                            iconPath: '/static/img/dingwei.png',
                            bgColor: '',
                            width: '20px',
                            height: '30px'
                        });
                    }
                })
            }
            this.modular = data.modular ? data.modular : [];

            if (this.activityDetail.groupId) {
                this.activityDetail.copyStatus = 1
            }
            if (data.active_state == 2) {
                this.activityDetail.is_it_over = 2
            }
            if (data.active_state == 1) {
                this.activityDetail.is_it_over = 3
            }
            this.active_state = data.active_state
            data.activityDetail['activity_big_type'] = data.activityDetail.activityBigType;
            data.activityDetail['activity_type'] = data.activityDetail.activityType;
            this.isType = data.activityDetail.activityType;
            this.signField = data.signField
            this.baseUrls = this.activityDetail.coverImg
            this.memberId = data.memberId
            if (this.modular.length > 2) {
                this.isHidden = true;
                this.hiddenBtn = true;
                this.zhanKai = true
            } else {
                this.isHidden = false;
                this.hiddenBtn = false;
            }
            if (data.mySignInfo) {
                this.mySignInfo = data.mySignInfo;
            } else {
                this.mySignInfo.id = ''
            }




            // 打卡信息
            if (data.clockInfo) {
                this.clockInfo = data.clockInfo;
                this.clockFrequencyType = data.clockInfo.clockFrequencyType;
                if (data.clockInfo.clockLocationInfo != "" && data.clockInfo.clockLocationInfo != null) {
                    this.clockInfo.clockLocationInfo = JSON.parse(data.clockInfo.clockLocationInfo)
                    this.covers.push({
                        id: 9001,
                        latitude: this.clockInfo.clockLocationInfo.latitude,
                        longitude: this.clockInfo.clockLocationInfo.longitude,
                        iconPath: '/static/img/dingwei.png',
                        bgColor: '',
                        width: '20px',
                        height: '30px'
                    });
                }
                this.setTimePickerConfig(this.clockFrequencyType);
                if (data.clockInfo.clockLocationStatus && data.clockInfo.clockLocationStatus == 1) {
                    this.isGetLocation()
                }
            }

            // 走check接口
            if (data.activityDetail.is_destination == 1) {
                this.isGetLocation()
            }

            if (data.project) {
                this.projectVos = data.project
            }

            if (data.cardReplacementsNumber) {
                this.cardReplacementsNumber = data.cardReplacementsNumber //剩余次数
            } else {
                this.cardReplacementsNumber = 0
            }
            this.cardReplacementsNumberFlag = data.cardReplacementsNumberFlag

          if (data.clockNameList) {
            this.clockNameList = data.clockNameList
            this.popupClockNameList = data.clockNameList

            this.clockNameList.map((res, index) => {
              if (res.clockName == "") {
                this.clockNameList.splice(index, 1)
              }
            })
            this.popupClockNameList.map((res, index) => {
              if (res.clockName == "") {
                this.clockNameList.splice(index, 1)
              }
            })
            // that.readNum = that.getRegistered()
            that.unreadNum =   this.clockNameList.length -that.readNum
            this.unreadClockNameList = this.clockNameList.filter((item) => item.clockNameStatus == 2)
            this.readClockNameList = this.clockNameList.filter((item) => item.clockNameStatus == 1 && item.name != null)
            this.cloneClocknameLength = this.clockNameList.length
          }
            if (this.templatePage == '1') {
                this.clockNameList = this.clockNameList.length > 0 ? this.clockNameList : this.clockNameListTemp;
                this.cloneClocknameLength = this.clockNameList.length
            }

            if (this.mySignInfo.id != "") {
                this.fmSignListId = data.mySignInfo.fm_sign_list_id ? data.mySignInfo.fm_sign_list_id : ''
            }

            this.sharefriendpic = `id=${this.activityId}&selectType=see${this.mySignInfo ? '&mySignInfo=' + this.mySignInfo.id : ''}`



            //开启留言时获取留言数据
            if (this.activityDetail.commentStatus == 1) {
                this.commentList = []
                this._getCommentList()
            }



            this.tosignClick = true
            this._getNoticeListMore()

        },
          //获取选手列表
          async _getSignListMore() {
            if (this.pageNum == 1) this.registraList = []
            let result = await getSignListMore({
                "pageNum": this.pageNum,
                "pageSize": 10,
                "signShowType": 1,
                "activityId":this.activityId,
                "fmSignListId": this.fmSignListId != 0 ? this.fmSignListId : null,
                "choose": this.isOtherPeople == 3 ? 1 : this.choose,
                "sortType": this.sortType,
                "name": this.name,
                "signInfoStatus": this.signInfoStatus != 0 ? this.signInfoStatus : null,
                "startQueryTime":this.startQueryTime,
                "endQueryTime":this.endQueryTime,
                "listGroupName":this.pickerName=='全部'?'':this.pickerName,
            })
            if (result.status == 1) {
                this.loadingFinished = false;
                this.loadingFlag = true;


                this.registraList = this.registraList.concat(result.data.pageInfo.list);

                console.log(this.registraList,'this.registraList')

                this.registraListTotal = result.data.pageInfo.total;
                this.registraPageNum = result.data.pageInfo.pageNum;
                this.registrapages = result.data.pageInfo.pages;
                this.hasMore = result.data.pageInfo.hasNextPage;

                if (result.data.pageInfo.pages == result.data.pageInfo.pageNum){
                    this.loadingFlag = false;
                    this.loadingFinished = true;
                }
                if (this.registraList.length == 0){
                    this.nodataFinished = true;
                    this.loadingFlag = false;
                    this.loadingFinished = false;
                } else {
                    this.loadingFlag = false;
                    this.nodataFinished = false;
                    this.loadingFinished = true;
                }

                this.registraList.forEach((item) => {
                    try {
                        item.sign_info = JSON.parse(item.sign_info)
                    } catch (e) {
                        console.error("解析错误:", e); // 将输出错误信息
                    }
                })
                this.registraList.map(itm => {
                    itm.sign_info.map((item) => {
                        item.isPlay = true
                        if (item.type == 12) {
                            this.covers.push({
                                id: 9005,
                                latitude: item.value.latitude,
                                longitude: item.value.longitude,
                                iconPath: '/static/img/dingwei.png',
                                bgColor: '',
                                width: '45px',
                                height: '60px'
                            })
                        }
                        if (item.type == '31'){
                            console.log(item.value,'item.value31')
                            if (item.value == undefined){
                                item['value'] = '';
                                item.startTime = '';
                                item.endTime = '';
                            } else if (!item.value.includes('undefined')){
                                var arr = item.value.split('~')
                                if (arr.length > 0){
                                    item.startTime = arr[0];
                                    item.endTime = arr[1];
                                } else {
                                    item.startTime = '';
                                    item.endTime = '';
                                }
                            } else if(item.value.includes('undefined')){
                                item['value'] = '';
                                item.startTime = '';
                                item.endTime = '';
                            }
                        }


                    })
                })
                this.cloneregistralength = Object.freeze(result.data.pageInfo.list);
                this.loadingFlag = false;
                this.isButtonClicked = false;

                this.isSearch = false
            } else {
                this.isButtonClicked = false;
                this.mescroll.endErr();
            }
            this.registraList.forEach(item => {
                const id = item.id;
                const currentState = this.commentStates[id] || { showCount: 2, isLastPage: false, pageNum: 1 ,totalRow:0};
                //     this.commentStates = {
                //     ...this.commentStates,
                //     [id]: item.id
                // };

                this._getSignListComment(id,currentState.pageNum)
            });

        },
        async _getSignListComment(id, num) {
            console.log(num,'123')
            num = num || 1;
            try {
                const pageNum = this.commentStates[id] ? this.commentStates[id].pageNum : num;
                console.log(pageNum,'pageNum')
                const res = await getSignListComment({
                    "activityId": this.activityId,
                    "pageNum": pageNum,
                    "pageSize": 2,
                    "orderId": id
                });
                if(this.commentStates[id] && this.commentStates[id].pageNum === 1){
                    this.pllist = this.pllist.filter(comment => comment.orderId !== id);
                }
                const currentComments = this.pllist.filter(comment => comment.orderId === id);
                const newComments = res.data.list;
                const updatedComments = currentComments.concat(newComments);

                this.pllist = this.pllist.filter(comment => comment.orderId !== id).concat(updatedComments);

                this.totalRow = res.data.total;
                this.pages = res.data.pages;
                this.plpageNum = res.data.pageNum;
                // remarkNum = res.data.remarkNum;
                const isLastPage = res.data.isLastPage;
                const totalRow  = res.data.total;
                // // 更新该对象的评论状态
                this.commentStates = {
                    ...this.commentStates,
                    [id]: {
                        ...this.commentStates[id],
                        pageNum: pageNum + 1, // 加载下一页
                        isLastPage,
                        totalRow
                        // remarkNum
                    }
                };

                console.log(res, 'res', this.commentList);
            } catch (error) {
                console.error('获取评论列表失败:', error);
            }
        },
       setTimePickerConfig(frequencyType) {
    let timePickerArr, dktimePickerArr, startQueryTime, endQueryTime;

    switch (frequencyType) {
        case 1: {
            let PickerArr = [
                { name: '本月', index: 0 },
                { name: '上月', index: 1 },
                { name: '自定义月份', index: 2 },
            ];
            dktimePickerArr = JSON.parse(JSON.stringify(PickerArr));
            timePickerArr = PickerArr;
            startQueryTime = this.$dayjs().startOf('month').format('YYYY-MM-DD');
            endQueryTime = this.$dayjs().endOf('month').format('YYYY-MM-DD');
            break;
        }
        case 2:
        case 6: {
            let PickerArr1 = [
                { name: '本周', index: 0 },
                { name: '上周', index: 1 },
                { name: '自定义周', index: 2 },
            ];
            dktimePickerArr = JSON.parse(JSON.stringify(PickerArr1));
            timePickerArr = PickerArr1;

            const startOfWeek = this.$dayjs().startOf('week').add(1, 'day');
            startQueryTime = startOfWeek.format('YYYY-MM-DD');
            const endOfWeek = this.$dayjs().endOf('week').add(1, 'day');
            endQueryTime = endOfWeek.format('YYYY-MM-DD');
            break;
        }
        case 3:
        case 4:
        case 5:
        case 7: {
            const PickerArr2 = [
                { name: '今天', index: 0 },
                { name: '昨天', index: 1 },
                { name: '自定义选择日期', index: 2 },
            ];
            dktimePickerArr = JSON.parse(JSON.stringify(PickerArr2));
            timePickerArr = PickerArr2;
            break;
        }
        default:
            console.error('Unknown clock frequency type:', frequencyType);
    }

    // 设置对象的属性
    this.dktimePickerArr = dktimePickerArr;
    this.timePickerArr = timePickerArr;
    this.startQueryTime = startQueryTime;
    this.endQueryTime = endQueryTime;
},
    getRegistered() {
        var registeredlist = this.filterClockNameList.filter((item) => item.clockNameStatus == 1&&item.name !=null)
        console.log(registeredlist,'registeredlist',this.clockNameList)
        return registeredlist.length
    },
    async _getProjectManageAdmin() {
        var that = this;
            let result = await getProjectManageAdmin({
                activityId: this.activityId
            })
            console.log(result,'---','invite=',this.invite)
            this.isOtherPeople = result.data;
            if (this.isOtherPeople == 3) {
                this.choose = 1
            }

            if (this.invite == 1 && this.isOtherPeople == 3) {
                that.$refs.memberPopShow.open()
            }
            console.log('星期2')
            this.firstDontGo = false;
            this._getSignListMore()
    }

    }
};
</script>

<template>
    <Layout>
        <div class="detailRow">
            <div class="outBox">
                <div class="activity-detail-container">
                    <div style="background-color: #fff;padding:20px">
                        <!-- 用户信息和标题 -->
                        <div class="creator">
                            <img src="https://ossfastmake.mustke.com//12jielong/lsyJL/anonymoushead.png"
                                v-if="templatePage == 1" />
                            <img :src="activityDetail.isanonymous == 1 ? activityDetail.profilePhoto : imageUrl2 + '/12jielong/lsyJL/anonymoushead.png'"
                                v-else />

                            <div class="" style="display: flex;flex-direction:column;">
                                <!-- <div class="footText">
                                    {{ activityDetail.nickname ? activityDetail.nickname : '' }}
                                </div> -->
                                <div class="footText" v-if="activityDetail.isanonymous == 1">
										{{ activityDetail.publisher ? activityDetail.publisher : '' }}
                                </div>
								<div class="footText" v-if="activityDetail.isanonymous == 0 ">
										匿名</div>

                                <div class="footTextTwo">
                                    <span> 发布时间:{{ activityDetail.addTime }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="Biao2" v-if="activityDetail.name">
                            {{ activityDetail.name }}
                        </div>
                        <!-- 内容 -->
                        <div style="position: relative">
                            <div class="Detailcontent" v-if="activityDetail.content">
                                <div class="con_Nei" v-html="activityDetail.content"></div>
                                <div class="sign" v-if="activityDetail.autographSwitch == 1"
                                    style="text-align: right;margin-top: 10px">
                                    {{ activityDetail.autograph ? activityDetail.autograph : '' }}
                                </div>
                                <div class="thumbs_box" v-if="activityDetail.thumbs_up === 1" @click="thumbsUp">
                                    <img :src="imageUrl2 + '/12jielong/lsyJL/already_liked.svg'" v-if="isNotice === '1'"
                                        alt="已点赞">
                                    <img :src="imageUrl2 + '/12jielong/lsyJL/thumbs_up_hollow.svg'"
                                        v-if="isNotice === '0'" alt="未点赞">
                                    <span>{{ activityDetail.noticeNumber }}</span>
                                </div>
                                <!-- <span class="fenge" v-if="templatePage != 1"></span> -->
                                <div class="lll">
                                    <span v-if="templatePage != 1">
                                        浏览量:{{ activityDetail.browseNum }}
                                    </span>
                                    <span v-if="templatePage == 1"> 浏览量:99999+</span>
                                </div>

                            </div>
                            <div class="fenge"></div>
                            <div v-for="(item, index) in modular" :key="index">
                                <!-- 内容 -->
                                <div class="newContentNew" v-if="item.type == 2 && item.info.value">
                                    <div class="newValue" v-if="item.isCloneTf == 1 && item.info.title != ''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{ item.info.title }}</div>
                                    </div>
                                    <div class="con_Nei">
                                        {{ item.info.value }}
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 小图片 -->
                                <div v-if="item.type == 3 && item.info.imgarr.length > 0" class="newContentNew">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title != '' && item.info.value != ''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{ item.info.value }}</div>
                                    </div>
                                    <!-- 图片 -->
                                    <div class="content5">
                                        <div v-for="(imgItem, imgIndex) in item.info.imgarr" :key="imgIndex"
                                            class="smallimg"
                                            :style="{ background: `url(${imageUrl2 + imgItem}) no-repeat center`, backgroundSize: 'cover', boxSizing: 'border-box' }"
                                            @click="OpenImage(index, imgIndex, 1)"></div>
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 大图片 -->
                                <div v-if="item.type == 9 && item.info.imgarr.length > 0" class="newContentNew">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title != '' && item.info.value != ''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{ item.info.value }}</div>
                                    </div>
                                    <!-- 图片 -->
                                    <div class="imgBIgNew">
                                        <img v-for="(imgItem, imgIndex) in item.info.imgarr" :key="imgIndex"
                                            :src="imageUrl2 + imgItem" @click="OpenImage(index, imgIndex, 1)"
                                            style="max-width:100%;display:block;margin-bottom:10px;">
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 地图 -->
                                <div class="newContentNew" v-if="item.type == 4 && item.info.address">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title != '' && item.info.value != ''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{ item.info.value }}</div>
                                    </div>
                                    <!-- 地图回显 -->
                                    <div class="huimapMap">
                                        <div class="mapMap">
                                            <div class="page-section page-section-gap" @click="handleGoto(item.info)"
                                                style="position:relative;">

                                                <div
                                                    style="position: absolute;z-index: 1;opacity: 0;left: 0;top: 0;width: 100%;height: 130px;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="page-map">
                                            <div style="font-weight: bold;font-size: 14px;">{{ item.info.name }}</div>
                                            <span style="font-size: 12px;color: #949EAF;">{{ item.info.address }}</span>
                                        </div>
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 文件 -->
                                <div class="newContentNew" v-if="item.type == 5">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title != '' && item.info.value != ''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{ item.info.value }}</div>
                                    </div>
                                    <div v-for="(fileItem, fileIndex) in item.info.filesArr" :key="fileIndex"
                                        @click="openWen(imageUrl2 + fileItem.fileUrl, fileItem.lastName, fileItem.name)">
                                        <div class="con4">
                                            <div class="con4Img">
                                                <img v-if="fileItem.lastName == 'doc'"
                                                    :src="imageUrl2 + '/static/announcement/word.png'" class="Img3">
                                                <img v-else-if="fileItem.lastName == 'docx'"
                                                    :src="imageUrl2 + '/static/announcement/word.png'" class="Img3">
                                                <img v-else-if="fileItem.lastName == 'pdf'"
                                                    :src="imageUrl2 + '/static/announcement/PDF.png'" class="Img3">
                                                <img v-else-if="fileItem.lastName == 'ppt'"
                                                    :src="imageUrl2 + '/static/announcement/PPT.png'" class="Img3">
                                                <img v-else-if="fileItem.lastName == 'xls'"
                                                    :src="imageUrl2 + '/static/index/excel.png'" class="Img3">
                                                <img v-else-if="fileItem.lastName == 'xlsx'"
                                                    :src="imageUrl2 + '/static/index/excel.png'" class="Img3">
                                                <img v-else-if="fileItem.lastName == 'zip'"
                                                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg"
                                                    class="Img3">
                                            </div>
                                            <div class="con4_1">
                                                <div>{{ fileItem.name }}</div>
                                                <span v-if="fileItem.size / 1024 <= 1">{{ setB(fileItem.size,
                                                    fileItem.lastName) }}</span>
                                                <span
                                                    v-else-if="fileItem.size / 1024 >= 1 && fileItem.size / 1048576 <= 1">{{
                                                    setKb(fileItem.size, fileItem.lastName) }}</span>
                                                <span v-else-if="fileItem.size / 1048576 >= 1">{{ setMb(fileItem.size,
                                                    fileItem.lastName) }}</span>
                                            </div>
                                        </div>
                                        <span class="fenge" style="margin-bottom: 30px"></span>
                                    </div>
                                </div>
                                <!-- 音频 -->
                                <div class="newContentNew" v-if="item.type == 6">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <div v-for="(fileItem, fileIndex) in item.info.filesArr" :key="fileIndex">
                                        <audio :src="imageUrl2 + fileItem.fileUrl" controls>
                                            Your browser does not support the audio element.
                                        </audio>
                                        <span class="fenge" style="margin-bottom: 30px"></span>
                                    </div>
                                </div>
                                <!-- 视频 -->
                                <div class="newContentNew" v-if="item.type == 7 && item.info.fileUrl">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <video :src="imageUrl2 + item.info.fileUrl" controls
                                        style="max-width:100%;width:807px;height:454px; display:block;margin-bottom:10px;">
                                        Your browser does not support the video element.
                                    </video>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 视频号 -->
                                <div v-if="item.type == 11" class="newContentNew" @click="toWebdiv('sph')">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <image :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <div class="new-m-content">
                                        <div class="show-one-line">{{ item.info.videoNumberTitle }}</div>
                                        <div class="btns-style">播放视频</div>
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 公众号 -->
                                <div v-if="item.type == 10" class="newContentNew" @click="toWebdiv('gzh')">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <div class="new-m-content">
                                        <div class="show-one-line">{{ item.info.officialAccountTitle }}</div>

                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 小程序 -->
                                <div v-if="item.type == 12" class="newContentNew" @click="toWebdiv('xcx')">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <div class="new-m-content">
                                        <div class="show-one-line">{{ item.info.appTitle }}</div>
                                        <div class="btns-style">打开</div>
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 一键复制区 -->
                                <div v-if="item.type == 13" class="newContentNew">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <div class="new-m-content">
                                        <div class="copybox">{{ item.info.copy_region_conten }}</div>
                                        <div class="copyStyle" @click="copyContent(item.info.copy_region_conten)">复制
                                        </div>
                                    </div>
                                    <span class="fenge"></span>
                                </div>
                                <!-- 关联接龙 -->
                                <div v-if="item.type == 14" class="newContentNew">
                                    <div class="newValue"
                                        v-if="item.isCloneTf == 1 && item.info.title!=''  && item.info.value!=''">
                                        <img :src="imageUrl2 + '/static/newOne/zise.png'" />
                                        <div class="Biao1">{{item.info.value}}</div>
                                    </div>
                                    <div v-for="(fileItem, fileIndex) in item.info.associationActivityId"
                                        :key="fileIndex">
                                        <div class="con5 con5_flex" @click="todetail(fileItem)">
                                            {{ fileItem.name }}

                                        </div>
                                        <u-line margin="20px" length="93%"></u-line>
                                    </div>
                                    <span class="fenge"></span>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="jlName" v-if="cloneClocknameLength > 0">
                        <div class="nameListTab">
                            <div class="tabs" @click="handelChangetab(0)"
                                :style="{ color: typeCopyIdx === 0 ? '#1877FF' : '#626974' }">
                                全部
                            </div>
                            <div class="tabs" @click="handelChangetab(1)"
                                :style="{ color: typeCopyIdx === 1 ? '#1877FF' : '#626974' }">
                                已读 ({{readNum}})
                            </div>
                            <div class="tabs" @click="handelChangetab(2)"
                                :style="{ color: typeCopyIdx === 2 ? '#1877FF' : '#626974' }">
                                未读 ({{unreadNum}})
                            </div>

                        </div>

                        <div class="listName"
                            :style="{marginBottom: activityDetail.userId == memberId?'10rpx': '30rpx'}">
                            <template v-if="typeCopyIdx==0">
                                <div class="span" v-for="(item, index) in clockNameList"
                                    @click="toSign(item.clockName,item.userId);"
                                    :style="{ backgroundColor: item.clockNameStatus == 1 && item.name != null ? '#EBF3FF' : '#F2F2F2', color: item.clockNameStatus == 1 && item.name != null ? '#1877FF' : '#626974' }"
                                    :key="index">
                                    <span v-if="activityDetail.clockNameNumberSwitch ==1">{{ index + 1 }}</span>
                                    <span>{{ item.clockName.length > 4 ?
                                        item.clockName.substring(0, 4) + '...' : item.clockName}}</span>
                                </div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                            </template>
                            <template v-if="typeCopyIdx==1">
                                <div v-if="readClockNameList.length>0" style="width: 100%;display: flex">
                                    <div class="span" v-for="(item, index) in readClockNameList"
                                        @click="toSign(item.clockName,item.userId);"
                                        :style="{ backgroundColor: '#EBF3FF', color: '#1877FF' }" :key="index">
                                        <div v-if="activityDetail.clockNameNumberSwitch ==1">{{ index + 1 }}</div>
                                        <span>{{ item.clockName.length > 4 ?
                                            item.clockName.substring(0, 4) + '...' : item.clockName}}</span>
                                    </div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                    <div class="spanDivEmpty"></div>
                                </div>

                                <div class="noneRecord" v-if="readClockNameList.length == 0">
                                    <img :src="imageUrl2 + '/static/gift/none.svg'">
                                    <span>暂无已读记录</span>
                                </div>
                            </template>
                            <template v-if="typeCopyIdx==2">
                                <div class="span" v-for="(item, index) in unreadClockNameList"
                                    @click="toSign(item.clockName,item.userId); "
                                    :style="{ backgroundColor: '#F2F2F2', color: '#626974' }" :key="index">
                                    <div>{{ index + 1 }}</div>
                                    <span>{{ item.clockName.length > 4 ?
                                        item.clockName.substring(0, 4) + '...' : item.clockName}}</span>
                                </div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>
                                <div class="spanDivEmpty"></div>

                                <div class="noneRecord" v-if="unreadClockNameList.length == 0">
                                    <img :src="imageUrl2 + '/static/gift/none.svg'">
                                    <span>暂无未读记录</span>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="player_content2">
                        <div class="peoples">
                            <div class="ptitle">通知记录 <span>({{readNum}}人)</span></div>
                        </div>
                        <div class="noticeContent">
                            <div class="titleT" v-for="(item,index) in noticeListMore" :key="index">
                                <div class="titleCon">
                                    <div class="titleTop">
                                        <div class="tx">
                                            <!-- 头像 -->
                                            <div class="header">
                                                <img :src="item.profile_photo">
                                            </div>
                                            <!-- 微信昵称 -->
                                            <div class="content_con">
                                                <div class="Biao">
                                                    {{item.nickname}}
                                                    <image class="no-see" v-if="item.allow_viewing==2"
                                                        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-nosee.svg">
                                                    </image>
                                                </div>

                                                <div class="time">
                                                    {{item.add_time}}
                                                </div>
                                            </div>
                                        </div>
                                        <img style="width: 20px" :src="imageUrl2+'/12jielong/lsyJL/signSet.svg'"
                                            alt="删除" @click.stop="delSign(item,index)"
                                            v-if="(item.user_id == memberId) || activityDetail.userId == memberId">
                                        <!--                            <span class="delSpan"  @click.stop="setSign(item,index)" v-if="(item.user_id == memberId) || activityDetail.userId == memberId">-->
                                        <!--                              <image :src="imageUrl2+'/12jielong/lsyJL/signSet.svg'"></image>-->
                                        <!--									          </span>-->
                                    </div>
                                    <div class="contentsign">
                                        <div class="bmfooter" hover-stop-propagation="true">
                                            <div class="footer_text">
                                                <span style="margin-right: 15rpx;">姓名</span> <span style="color: #333;">
                                                    {{item.name}} 确认收到</span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="noneRecord" v-if="noticeListMore.length ==0">
                            <img :src="imageUrl2 + '/static/gift/none.svg'">
                            <span>~暂无相关数据~</span>
                        </div>

                    </div>

                </div>
                <div class="view-box">
                    <div class="view-box-item">
                        <div class="share-box"  style="display: flex;flex-direction: column;justify-content: center;align-items: center;" @click.stop="shareClick(activityDetail)">
                            <el-button icon="el-icon-share" type="text" size="medium"></el-button>
                            <span style="color: #323B5A;font-size: 12px;">分享</span>
                        </div>
                    </div>
                    <div class="view-box-item">
                        <el-dropdown v-if="isOtherPeople == 1 || isOtherPeople == 2" trigger="click" @mousedown.stop
                            @click.stop>
                            <!-- <el-button type="text" icon="el-icon-setting" class="el-dropdown-link" @click.stop>
                                管理
                            </el-button> -->
                            <div class="share-box" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                                <el-button icon="el-icon-setting" type="text" size="medium"></el-button>
                                <span style="color: #323B5A;font-size: 12px;">管理</span>
                            </div>
                            <el-dropdown-menu slot="dropdown" @mousedown.stop @click.stop class="management-dropdown">
                                <!-- 通知公告、通用接龙 -->
                                <template>
                                    <el-dropdown-item icon="https://ossfastmake.mustke.com/12jielong/lsyJL/sorticon.png"
                                        @click.native="dropdownSet(activityDetail)">编辑</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-user-solid"
                                        @click.native="setAdmin(activityDetail)">设置管理员</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-link"
                                        @click.native="exportData(activityDetail)">导出数据</el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-document-copy"
                                        @click.native="dropdownCopy(activityDetail)">复制</el-dropdown-item>
                                    <el-dropdown-item
                                        v-if="activityDetail.active_state == 1 || activityDetail.active_state == 2 || activityDetail.active_state == 3"
                                        icon="el-icon-time" @click.native="dropdownEnd(activityDetail)">
                                        {{ activityDetail.active_state == 1 ? "立即开始" : activityDetail.active_state == 2
                                        ? "重启活动" : "提前结束" }}
                                    </el-dropdown-item>
                                    <el-dropdown-item icon="el-icon-delete"
                                        @click.native="dropdownDel(activityDetail)">删除</el-dropdown-item>
                                </template>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="share-box" v-else @click.stop="dropdownCopy(activityDetail)">
                            <el-button icon="el-icon-document-copy" type="text" size="small"></el-button>
                            <span style="color: #323B5A;">复制</span>
                        </div>
                    </div>
                </div>
                <div class="btn_box" @click="toSign()">
                    确认收到通知

                </div>
            </div>

            <!-- <el-date-picker v-model="weekPicker" type="week" format="yyyy 第 WW 周" placeholder="选择周">
            </el-date-picker>
            <el-date-picker v-model="monthShow" type="month" placeholder="选择月">
            </el-date-picker>-->
            <el-dialog :visible.sync="dialogVisible" width="455px" center :show-close="false">
                <template slot="title">
                    <CustomDialogHeader
                        title="分享"
                        @close="dialogVisible = false"
                    />
                </template>
                <div style="
          text-align: center;
          background-color: #fff;
          padding-top: 0px;
          padding-bottom: 30px;
        ">
                    <div class="radioBack">
                        <el-radio-group v-model="shareChange" fill="#1877ff">
                            <el-radio-button border="false" label="下载接龙二维码"></el-radio-button>
                            <el-radio-button border="false" label="嵌入公众号/文章"></el-radio-button>
                        </el-radio-group>
                    </div>
                    <div v-show="shareChange == '下载接龙二维码'">
                        <div>
                            <el-image :src="codeUrl" class="code-image"></el-image>
                        </div>
                        <el-button @click="downLoadCodePic(codeUrl)" type="primary" round
                            style="margin-top: 40px">下载接龙二维码</el-button>
                        <p style="text-align: left; margin-left: 20px; font-weight: 600" v-if="JumpUrl">
                            活动链接
                        </p>
                        <div style="
              background-color: #fff;
              margin: 10px;
              height: 83px;
              margin-left: 20px;
              margin-right: 20px;
              border-radius: 10px;
              border: 1px solid #e8e8e8;
            " v-if="JumpUrl">
                            <p style="
                padding: 5px;
                font-size: 16px;
                text-align: left;
                margin-left: 5px;
              ">
                                {{ JumpUrl }}
                            </p>

                            <button style="
                cursor: pointer;
                background-color: rgb(64, 158, 255);
                color: white;
                font-size: 12px;
                width: 50px;
                height: 28px;
                border-radius: 15px;
                margin-top: -10px;
                margin-left: 300px;
                border: none;
              " @click="copyClick(JumpUrl)" v-if="JumpUrl">
                                复制
                            </button>
                        </div>
                    </div>
                    <div v-show="shareChange == '嵌入公众号/文章'" class="wzClass">
                        <div style="
              width: 330px;
              height: 85px;
              background-color: white;
              border-radius: 5px;
              margin: 10px;
              padding: 10px;
              margin-left: 10px;
              /* margin-top: 20px; */
            ">
                            <div style="display: flex">
                                <span style="
                  color: #474747;
                  font-weight: 300;
                  width: 83px;
                  text-align: left;
                ">小程序ID:</span>
                                <span style="
                  color: #010100;
                  font-weight: 400;
                  width: 200px;
                  text-align: left;
                ">{{ appid }}</span>
                            </div>
                            <div style="
                display: flex;
                justify-content: space-between;
                margin-left: 0px;
                margin-top: 15px;
              ">
                                <div>
                                    <span style="color: red; line-height: 28px; text-align: left">*</span>
                                    <span style="
                    color: #1877ff;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 28px;

                    text-align: left;

                  ">关联小程序时使用</span>

                                </div>

                                <el-button size="mini" round type="primary" @click="copyClick(appid)" style="background-color: #1877ff;color:#ffffff;">

                                    复制

                                </el-button>

                            </div>

                        </div>



                        <div style="
              width: 330px;
              height: 100px;
              background-color: white;
              border-radius: 5px;
              margin: 10px;
              padding: 10px;
              margin-left: 10px;
            ">
                            <div style="display: flex">
                                <span style="
                  color: #474747;
                  font-weight: 300;
                  width: 83px;
                  text-align: left;
                ">页面路径:</span>

                                <span style="
                  color: #010100;
                  font-weight: 400;
                  width: 200px;
                  text-align: left;
                ">{{ faceUrl }}</span>
                            </div>
                            <div style="
                display: flex;
                justify-content: space-between;
                margin-left: 0px;
                margin-top: 15px;
              ">
                                <div>
                                    <span style="color: red; line-height: 28px; text-align: left">*</span>
                                    <span style="
                    color: #1877ff;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 28px;
                    text-align: left;
                  ">嵌入菜单，文章，回复时使用</span>
                                </div>
                                <el-button size="mini" round type="primary" @click="copyClick(faceUrl)"  style="background-color: #1877ff;color:#ffffff;">
                                    复制
                                </el-button>
                            </div>
                        </div>
                        <div style="
              width: 330px;
              background-color: white;
              border-radius: 5px;
              margin: 10px;
              padding: 10px;
              margin-left: 10px;
            ">
                            <div style="
                text-align: center;
                font-size: 20px;
                font-weight: 500;
                margin-top: 30px;
              ">
                                使用教程

                            </div>



                            <div style="margin-top: 10px; margin-bottom: 10px">

                                <button style="cursor: pointer" :class="isAcive == '嵌入到公众号' ? 'acStyle' : 'defStyle'"
                                    @click="clickHandler('嵌入到公众号')">

                                    嵌入到公众号

                                </button>

                                <button style="cursor: pointer" :class="isAcive == '嵌入到文章' ? 'acStyle' : 'defStyle'"
                                    @click="clickHandler('嵌入到文章')">

                                    嵌入到文章

                                </button>

                                <!-- kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg -->

                            </div>

                            <div v-show="isAcive == '嵌入到公众号'">

                                <el-image style="width: 300px" :src="require('@/assets/images/qrgzh.jpg')">

                                </el-image>

                            </div>

                            <div v-show="isAcive == '嵌入到文章'">

                                <el-image style="width: 300px"
                                    :src="imageUrl + 'kEu47kwFr2oOr9rO/modularImg/1707035652084.jpg'">

                                </el-image>

                            </div>

                        </div>

                    </div>

                </div>

            </el-dialog>
            <el-dialog  custom-class="dialogClass" :visible.sync="manageDialogVisible" width="455px"
                center :show-close="false">
                <template slot="title">
                    <CustomDialogHeader
                       :title="manageTitle"
                        @close="manageDialogVisible = false"
                    />
                </template>
                <div style="
                    text-align: center;
                    background-color: #f6f7fa;
                    padding-top: 0px;
                    padding-bottom: 30px;
                  ">
                    <div>
                        <el-image :src="codeUrl" class="code-image"></el-image>
                    </div>
                    <div>{{ manageTip }}</div>
                    <el-button @click="downLoadCodePic(codeUrl)" type="primary" round
                        style="margin-top: 40px; background-color: #1877ff;color:#ffffff;" >下载接龙二维码</el-button>
                </div>
            </el-dialog>



        </div>
    </Layout>
</template>
<style lang="scss" scoped>
.detailRow{
    display: flex;
     flex-wrap: wrap;
     margin-right: -12px;
     margin-left: -12px;
    background: #F7F9FF;
}
.select-list-box span{
    display: inline-block;
    padding: 0 17px;
    height: 31px;
    /*background: #1877ff;*/
    border-radius: 26px;
    border: 1px solid #d8d8d8;
    font-size: 12px;
    line-height: 31px;
    text-align: center;
    margin: 5px;
}
.activity-detail-container {
    margin: 0 auto;
    border-radius: 8px;
    font-family: "Microsoft YaHei", Arial, sans-serif;
}

.user-info-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 16px;
}

.user-meta {
    display: flex;
    flex-direction: column;
}

.user-name {
    font-size: 16px;
    font-weight: bold;
    color: #222;
}

.publish-time {
    font-size: 13px;
    color: #888;
    margin-top: 2px;
}

.creator {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    img {
        width: 41px;
        height: 41px;
        border-radius: 50%;
        margin-right: 14px;
    }

    .footText {
        font-size: 14px;
        font-weight: 600;
        color: #636A84;
        max-width: 225px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .footTextTwo {
        font-size: 12px;
        color: #A3A7AD;
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
    }
}

.Biao2 {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #323b5a;
}

.Detailcontent {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #4c4a56;
    line-height: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 809px;
    // text-indent: 2rem;
}

.fenge {
    width: 100%;
    height: 1px;
    background: #dedede;
    margin: 19px 0 8px;
}

.lll {
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: right;
    color: #a2a2a2;
    line-height: 17px;
}

.main-title {
    font-size: 14px;
    font-weight: bold;
    color: #222;
    margin-bottom: 10px;
}


.newContentNew {
    width: 100%;
    background-color: #FFFFFF;
    margin-bottom: 5px;
    border-radius: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .newValue {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 18px;

        img {
            width: 4px;
            height: 20px;
            margin-right: 4.5px;
        }
    }

    .imgBIgNew {
        width: 100%;

        img {
            width: 100%;
            // height: 167.5px;
        }
    }

    .content5 {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .smallimg {
            width: 188px;
            height: 188px;
            margin: 0 3px 6.5px 3px;
            border-radius: 3px;
        }

        img {
            width: 188px;
            height: 188px;
            margin: 0 7px 6.5px 7px;
            border-radius: 3px;
            background: #ddd;
            object-fit: contain;
        }
    }

    // 地图
    .mapTitle {
        width: 100%;
        height: 2rem;
        text-align: center;
    }

    .huimapMap {
        display: flex;
        flex-direction: column;
        background-color: #FAFAFA;
        border-radius: 4px;

        .page-map {
            padding-left: 13px;
            box-sizing: border-box;
        }
    }

    .mapMap {
        height: 8.5rem;
        position: relative;
    }

    // 文件
    .con4 {
        width: 335px;
        height: 66px;
        background-color: #F8F8F8;
        border-radius: 6px;
        display: flex;
        align-items: center;
        padding: 16px;
        box-sizing: border-box;

        .con4Img {
            width: 27px;
            height: 29.5px;
            margin-right: 18px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .con4_1 {
            display: flex;
            flex-direction: column;

            div {
                font-size: 15px;
                font-weight: bold;
                color: #333333;
            }

            span {
                font-size: 14px;
                color: #A3A7AD;
            }
        }
    }

    .audio-play {
        width: 100%;
        display: flex;
        align-items: center;
        background-color: #F8F8F8;
        align-items: flex-start;
        border-radius: 8px;
        padding: 10px;
        box-sizing: border-box;

        .playIcon {
            margin-right: 10px;
        }

        .playtext {
            font-size: 14px;
            font-weight: bold;
        }
    }
    .con5 {
        width: 315px;
        height: 51px;
        background: #f8f8f8;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: Medium;
        text-align: left;
        color: #333333;
        line-height: 51px;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 7.5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

.completion-status {
    border: 1px solid #E0E0E0;
    padding: 10px;
    margin-top: 20px;
    background-color: #FBFBFB;
    margin-top: 10px;
}

.status-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
}

.notify-button {
    background-color: #1877FF;
    color: #FFF;
    border: none;
    border-radius: 4px;
    padding: 5px 10px;
    cursor: pointer;
}

.participant-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.participant {
    background-color: #F4F7FE;
    padding: 5px 10px;
    border-radius: 4px;
    color: #333;
}
.section-title {
    font-size: 15px;
    font-weight: bold;
    color: #1877ff;
    margin: 18px 0 10px 0;
}

.big-image-box {
    width: 100%;
    margin-bottom: 18px;
}

.big-image {
    width: 100%;
    max-width: 834px;
    border-radius: 8px;
    object-fit: cover;
    display: block;
}

.small-image-list {
    display: flex;
    gap: 16px;
    margin-bottom: 18px;
}

.small-image {
    width: 130px;
    height: 130px;
    border-radius: 8px;
    object-fit: cover;
    background: #f6f6f6;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.map-box {
    margin-top: 10px;
    width: 100%;
    background: #fafbfc;
    border-radius: 8px;
    padding: 16px;
}

.map-img {
    width: 100%;
    height: 200px;
    border-radius: 8px;
    object-fit: cover;
    display: block;
}

.map-desc {
    font-size: 13px;
    color: #666;
    margin-top: 8px;
    line-height: 1.6;
}

.b-marT-10 {
    margin-top: 10px;
}

.b-marT-20 {
    margin-top: 20px;
}
.all_div16{
    width: 100%;
    // background-color: #F8F8F8;
    // padding: 20px 0;
    box-sizing: border-box;
    margin: 20px auto;

}
/* flex布局 */
.flex-depart-left {
    display: flex;
    align-items: center;
}

.flex-depart-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flex-depart-center-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flex-depart-center-end {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.flex-depart-top {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.flex-depart-left-warp {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.new-m-content {
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #F8F8F8;

    div {
        width: 80%;
        word-break: break-all;
        font-size: 14px;
        font-weight: bold;
        color: #477aff;
    }
}

.new-m-content .copyStyle {
    width: 86px !important;
    height: 30px;
    background: #ffffff;
    border: 2px solid rgba(24, 119, 255, 0.17);
    border-radius:18px;
    font-size:12px;
    color: #1877FF;
    display: flex;
    justify-content: center;
    align-items: center;
}

.new-m-content .copybox {
    white-space: pre-wrap;
}
/*大图排序*/
.flex-depart-column-top-left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}


.outBox {
    width: 850px;
    margin: 0 auto;
    background-color: #FBFBFB;
    position: relative;
}

.bigTitle {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: white;
    font-weight: bold;
    background-color: #1877FF;
}

.block-title {
    font-size: 14px;
    font-weight: Bold;
    text-align: left;
    color: #191919;
}

.blockBox {
    padding: 15px;
    background-color: white;
    margin-bottom: 10px;
}


.handle-box .h-item {
    margin-right: 30px;
    cursor: pointer;
}

.handle-box .h-item img {
    width: 20px;
    height: 20px;
    margin-right: 1px;
}

.handle-box .h-item span {
    font-size: 12px;
    color: #767d98;
}

.addBtnStyle {
    width: 285px;
    height: 43px;
    background: #ffffff;
    border: 1px dashed #4a73f7;
    border-radius: 23px;
    font-size: 16px;
    color: #1877ff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    i {
        margin-right: 10px;
    }
}

.f-block {
    background: #fafafa;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 10px;
    margin-top: 10px;
}

.f-block:last-child {
    /*margin-bottom: 0;*/
}

.tl-item .f-ipt {
    width: 780px;
}

.f-handle img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
    cursor: pointer;
}

.checkedState .el-checkbox {
    margin-bottom: 0;
}

.ch-copy {
    margin-left: 50px;
    font-size: 13px;
    color: #1877ff;
    align-items: center;
    cursor: pointer;

    i {
        /*width: 17px;*/
        /*height: 17px;*/
        margin-right: 4px;
    }

}

.selectBox-item {
    padding-left: 20px;
}

.selectBox-item .el-input {
    width: 700px;
    margin-right: 10px;
}

.selectBox-item i {
    font-size: 18px;
}

.addOptStyle {
    color: #1877ff;
    cursor: pointer;
    padding-left: 20px;
}

.settingBox {
    padding: 10px 15px;
    background-color: white;
}

.sTitle {
    font-size: 14px;
    font-weight: Bold;
    text-align: left;
    color: #191919;
    display: inline-flex;
    align-items: center;

    label {
        font-size: 12px;
        color: grey;
        font-weight: normal;
    }

    b {
        width: 4px;
        height: 14px;
        background: #1877ff;
        border-radius: 2px;
        margin-right: 5px;
    }
}

.settingBox .el-date-editor .el-range-separator {
    width: 15%;
}

.setText {
    color: #1877ff;
    cursor: pointer;
    text-decoration: underline;
}

.settingBox .el-radio {
    margin-bottom: 0;
}

.block-for-box {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    margin-top: 10px;
}

.big-img img {
    max-width: 600px;
    height: auto;
}

.b-handle img {
    width: 20px;
    height: 20px;
    margin: 5px;
    cursor: pointer;
}

.addSmallBtn {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F7F7F7;
    color: #1877ff;
    border-radius: 4px;
    position: relative;

}

.updateFileBtn {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.rangeTimes i {
    margin-left: 5px;
    font-size: 25px;
    cursor: pointer;
    color: #F56C6C;
}

.add-rangeTimes {
    color: #1877ff;
    cursor: pointer;
}

.map {
    width: 100%;
    height: 400px;
}

.deadline {
    width: 80px;
    margin-left: 5px;
}
.jlName {
    width: 100%;
    background: #ffffff;
    margin: 10px auto 0 auto;
    border-radius: 5px;
    background-color: #fff;
    padding: 6px 15px;
    box-sizing: border-box;
    padding: 17.5px 30px;

    .jlName_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 8px;
        margin-bottom: 10px;
    }
  .nameListTab{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .tabs{
      margin-right: 10px;
      color: #555555;
      font-size: 16rpx;
    }
  }
    .copynamelist {
        width: 121px;
        height: 26px;
        background: #1877ff;
        border-radius: 15px;
        font-size: 14px;
        color: #fff;
        line-height:26px;
        text-align: center;


    }

    .listName {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        justify-content: space-between;

      .span {
        height: 50px;
        width: 10%;
        margin: 4px;
        background-color: #F2F2F2;
        border-radius: 4px;
        text-align: center;
        font-size: 12px;
        color: #626974;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      .spanDivEmpty{
        height: 0px;
        width: 10%;
        margin: 4px;
      }

    }
}
.smallImgbox {
    width: 150px;
    height: 150px;
    background-color: #F7F7F7;
    margin: 5px;
    position: relative;
}

.handle2 {
    width: 150px;
    height: 150px;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
    display: none;

    img {
        width: 20px;
        height: auto;
        cursor: pointer;
        margin-top: 70px;
        margin-left: 33px;
    }
}

.seeBigImgHover:hover {
    .handle2 {
        display: block;
    }
}

.imgBg {
    width: 150px;
    height: 150px;
    /*background: url("https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg") no-repeat center;*/
    background-size: cover;

}

.upl-smallImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 150px;
    background-color: #F7F7F7;
    color: #1877ff;
    cursor: pointer;
    margin: 5px;
    position: relative;

    i {
        font-size: 26px;
    }
}

.filesStyle {
    height: 45px;

    .tubiao {
        margin-right: 2px;
    }

    .del {
        margin-left: 10px;
        position: relative;
        top: 1px;
        cursor: pointer;
    }

    img {
        width: 20px;
        height: 20px;
        margin-right: 5px;
    }
}

.predivImgBox {
    width: 100%;
    height: 100%;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .inner-p-img {
        height: 600px;
        width: auto;
    }

    .closePImg {
        font-size: 40px;
        cursor: pointer;
        position: fixed;
        top: 40px;
        right: 40px;
        color: white;
    }
}

.drawerOutBox {
    padding: 0 20px;
}

.af-title {
    font-weight: bold;
}

.ty-b-item {
    position: relative;
    width: 195px;
    height: 80px;
    border: 1px solid #B2C4FB;
    background-color: #F4F7FE;
    border-radius: 5px;
    box-sizing: border-box;
    padding-top: 18px;
    padding-left: 10px;
    cursor: pointer;
}

.ty-b-item div {
    font-weight: bold;
    color: #1877FF;
}

.addFBtn {
    color: #1877FF;
    font-size: 22px;
    position: absolute;
    right: 10px;
    top: 18px;
}

.cy-box {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}

.cy-item {
    width: 128px;
    height: 45px;
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #F4F7FE;
    border-radius: 5px;
    margin-bottom: 5px;
    cursor: pointer;

    .addFBtn2 {
        color: #1877FF;
        font-size: 22px;
    }
}

.seniorStyle {
    background-color: #ECF4FF !important;
    cursor: pointer;
}

.cus-dates {
    margin-bottom: 0 !important;
    margin-left: 5px;
}

.comment_cont{
    width: 100%;
    /*min-height: 63px;*/
    background: #E8F2FF;
    border-radius: 2px;
    padding: 7.44px;
    font-size: 14px;
    text-align: left;
    color: #1877FF;
    line-height: 20px;
    padding-left: 8px;
    word-wrap: break-word;   //自动换行
    word-break: break-all;    //自动换行（兼容字母）
    overflow: hidden;       //超出隐藏
    text-overflow: ellipsis;   //溢出显示省略号
    display: -webkit-box;
    /*-webkit-line-clamp: 3;   //显示3行*/
    -webkit-box-orient: vertical;
}
.content5-new{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
}
.image-wrapper-new{
    width: calc(100% / 4 - 10px);
    height: 189px;
    position: relative;
    margin: 8px 0;
    .con5-img{
        width: 100%;
        height: 100%;
    }
}
.image-wrapper-new-empty{
    width: calc(100% / 4 - 10px);
    height: 0;
    margin: 8px 0;
}
.image-wrapper-new-100{
    width: 100%;
    height: 503px;
    position: relative;
    margin: 8px 0;
    .con5-img{
        width: 100%;
        height: 100%;
    }
}
// 文件
.con4 {
    width: 100%;
    height: 40px;
    background-color: #F8F8F8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 16px;
    box-sizing: border-box;
    justify-content: space-between;
    margin-bottom: 10px;
    cursor: pointer;
    .con4Img {
        width: 13px;
        height: 15px;
        margin-right: 18px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .con4_1 {
        display: flex;


        div {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
        }

        span {
            font-size: 14px;
            color: #A3A7AD;
        }
    }
}
.thumbs_box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-right:33px;
    justify-content: center;
    border: 1px solid #1877ff;
    border-radius: 32px;
    padding: 0 20px;
    width: 60px;
    margin: 10px auto;
    height:30px ;
    img{
        width: 19px;
        height: 18px;
        margin-right: 5px;
    }
    text{
        font-size: 20px;
        font-weight: Regular;
        text-align: left;
        color: #1877ff;
    }
}
.scoreBox {
    .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .line {
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }
    .score_content {
        margin-bottom: 20px;
    }
    .score_bottom {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
}
.scoreBox {
    .top {
        margin-bottom: 20px;
    }
    .score_content {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;
    }
    .scoremodel {
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
        color: #fff;
    }
    .scoreinputmodel {
        width: 100%;
    }
    .score_bottom {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
}


.loading-style {
    text-align: center;
    color: #999;
    margin-top: 20px;
}

.none-record {
    text-align: center;
    color: #999;
    margin-top: 20px;
}

.none-record img {
    width: 100px;
    height: auto;
    margin-bottom: 10px;
}

.text.item {
    display: flex;
    align-items: center;
}

.text.item .contenttz {
    margin-left: 10px;
}

.float-right {
    float: right;
}
.noneRecord {
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;

  image {
    width: 200px;
    height: 141px;
  }

  span {
    margin-top: 30px;
    font-size: 16px;
    color: gray;
  }
}
.player_content2{
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  padding: 20px;
  padding-top: 0;
  .noticeContent{
    .titleT{
      width: 100%;
      .titleCon{
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 28px 0;
        box-sizing: border-box;
        border-radius: 5px;
        padding-bottom: 10px;
        border-bottom: 1px solid #E4E4E4;
        .titleTop{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 12px;
          .tx{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .header{
              margin-right: 20px;
              img{
                width: 47px;
                height: 47px;
                border: 1px solid #ccc;
                border-radius: 50%;
              }
            }
            .content_con{
              .Biao{
                width: 400px;
                font-weight: bold;
                font-size: 15px;
                margin-bottom: 4px;
                color: #323B5A;
                display: flex;
              }
              .time{
                font-size: 12px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                text-align: left;
                color: #666666;
                margin-top: 6px;
              }
            }
          }
        }

        .content{
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .bmfooter{
            width: 100%;
            font-size: 14px;
            color: #626974;
            box-sizing: border-box;
          }
          .footer_text{
            view{
              /*margin: 8px 0;*/
            }
            .mar15-0{
              margin: 8px 0;
            }
            span{
              word-break: break-all;
            }
            .newContent{
              width: 100%;


              .nameMa{
                width: 100%;
                // display: flex;
                // flex-direction: column;
                .imgMa{
                  width: 316px;
                  height: 316px;
                  img{
                    width: 100%;
                    height: 100%;
                  }
                }
              }
              .greenBtn{
                width: 100%;
                height: 77px;
                background-color: #03CE66;
                border-radius: 38.5px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 20px 29px;
                box-sizing: border-box;
                img{
                  width: 32px;
                  height: 40px;
                  margin-right: 29px;
                }
                span{
                  font-size: 30px;
                  color: #FFFFFF;
                }
              }
              .content5{
                // width: 668px;
                // height: 402px;
                display: flex;
                flex-wrap: wrap;
                // margin-bottom: 60px;
                img{
                  width: 190.5px;
                  height: 190.5px;
                  margin: 0 14px 13px 14px;
                  border-radius: 6px;

                }
              }
              .mapMap{
                width: 653px;
                // height: 246px;
              }
              .page-map{
                width: 100%;
                height: 33px;
                line-height: 33px;
                background: #E8F2FF;
                border-radius: 2px;
                font-size: 14px;
                color: #1877FF;
                align-items: center;
                padding: 0 15px;
                .map-posi{
                  width: 20px;
                  height: 20px;
                  position: relative;
                  top: 2px;
                }
              }
            }
          }
        }
        .delSpan {
          font-size: 24px;
          color: #0291FF;
          image {
            position: absolute;
            right: 20px;
            width: 60px;
            height: 30px;
          }
        }
      }
      .pllist{
        width: 100%;
        min-height: 50px;
        background: #eef2f7;
        border-radius: 10px;
        padding:8px;
        .pltx{
          width: 45px;
          height: 45px;
          background: #d8d8d8;
          border: 3px solid #ffffff;
          border-radius: 50%;
        }
        .plName{
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: bold;
          text-align: left;
          color: #666666;
          margin: 0 8px;

        }
        .plContent{
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: Semibold;
          text-align: left;
          color: #666666;
        }
      }
    }
  }
}
.btn_box{
  width: 416px;
  height: 50px;
  background: #1877ff;
  border-radius: 25px;
  margin: 20px auto;
  text-align: center;
  line-height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translate(-32%);
  cursor: pointer;
}
.con_Nei {
  width: 100%;
  font-size: 30rpx;
  color: #4b5668;
  // word-break: break-all;  、
  box-sizing: border-box;
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 45rpx;
}
.view-box{
  width: 50px;
  height: 120px;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
    top: 20%;
  left: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
    margin-left: 550px;
}

.view-box-item {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-box-item .el-button {
  width: 100%;
  height: auto;
  padding: 6px 4px;
  font-size: 20px;
  line-height: 1.2;
  border: none;
  background: transparent;
  color: #1877ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


/* 管理下拉菜单样式 */
::v-deep .management-dropdown {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e4e7ed;
  padding: 6px 0;
  min-width: 140px;
  background: #ffffff;
}

::v-deep .management-dropdown .el-dropdown-menu__item {
  padding: 10px 16px;
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  display: flex;
  align-items: center;
}

::v-deep .management-dropdown .el-dropdown-menu__item i {
  margin-right: 8px;
  font-size: 14px;
  color: #1877ff;
}

::v-deep .management-dropdown .el-dropdown-menu__item:hover {
  background-color: #f5f7fa;
  color: #1877ff;
}

::v-deep .management-dropdown .el-dropdown-menu__item.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

::v-deep .management-dropdown .el-dropdown-menu__item.is-disabled i {
  color: #c0c4cc;
}

::v-deep .management-dropdown .el-dropdown-menu__item.is-disabled:hover {
  background-color: transparent;
  color: #c0c4cc;
}

::v-deep .el-dropdown-link {
  color: #1877ff;
  font-size: 14px;
  border: none;
  background: transparent;
  padding: 0;
}

::v-deep .el-dropdown-link:hover {
  color: #1877ff;
}

::v-deep .el-dropdown-link:focus {
  outline: none;
}
.radioBack .el-radio-group {

border-radius: 40px;

overflow: hidden;

border: 1px solid #1877ff;

}

.radioBack .el-radio-button {

// width: 120px;

margin: 0;

}

.radioBack .el-radio-button__inner {

color: #1877ff;

border: 0px solid #1877ff;

font-size: 12px;

}



::v-deep .el-radio-button__inner {

color: #1877ff;

}



.code-image {

margin-top: 40px;

width: 200px;

height: 200px;

}

.acStyle {

width: 120px;

height: 30px;

background-color: #1877ff;

color: white;

font-size: 12px;

border: 0;

}



.defStyle {

width: 120px;

height: 30px;

background-color: white;

color: #1877ff;

font-size: 12px;

border: 1px solid #1877ff;

}
</style>
